// @generated by protobuf-ts 2.11.1 with parameter long_type_string,generate_dependencies,output_legacy_commonjs
// @generated from protobuf file "sennotech/posture/posture.proto" (package "algorithm.posture", syntax proto3)
// tslint:disable
import { Empty } from "../../google/protobuf/empty";
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { DoubleValue } from "../../google/protobuf/wrappers";
import { Int32Value } from "../../google/protobuf/wrappers";
import { Timestamp } from "../../google/protobuf/timestamp";
import { Int64Value } from "../../google/protobuf/wrappers";
import { BoolValue } from "../../google/protobuf/wrappers";
import { StringValue } from "../../google/protobuf/wrappers";
/**
 * @generated from protobuf message algorithm.posture.GetLicenseInfoByAccountIdAndClientRequest
 */
export interface GetLicenseInfoByAccountIdAndClientRequest {
    /**
     * @generated from protobuf field: int64 accountId = 1
     */
    accountId: string;
    /**
     * @generated from protobuf field: google.protobuf.StringValue client = 2
     */
    client?: StringValue;
}
/**
 * @generated from protobuf message algorithm.posture.GetLicenseInfoByAccountIdAndClientResponse
 */
export interface GetLicenseInfoByAccountIdAndClientResponse {
    /**
     * @generated from protobuf field: algorithm.posture.LicenseInfoResult licenseInfoResult = 1
     */
    licenseInfoResult?: LicenseInfoResult;
}
/**
 * @generated from protobuf message algorithm.posture.GetLicenseInfoByAccessTokenAndClientRequest
 */
export interface GetLicenseInfoByAccessTokenAndClientRequest {
}
/**
 * @generated from protobuf message algorithm.posture.GetLicenseInfoByAccessTokenAndClientResponse
 */
export interface GetLicenseInfoByAccessTokenAndClientResponse {
    /**
     * @generated from protobuf field: algorithm.posture.LicenseInfoResult licenseInfoResult = 1
     */
    licenseInfoResult?: LicenseInfoResult;
}
/**
 * @generated from protobuf message algorithm.posture.GetLicenseInfoByOrganizationIdAndClientRequest
 */
export interface GetLicenseInfoByOrganizationIdAndClientRequest {
    /**
     * @generated from protobuf field: int64 organization_id = 1
     */
    organizationId: string;
    /**
     * @generated from protobuf field: string client = 2
     */
    client: string;
}
/**
 * @generated from protobuf message algorithm.posture.GetLicenseInfoByOrganizationIdAndClientResponse
 */
export interface GetLicenseInfoByOrganizationIdAndClientResponse {
    /**
     * @generated from protobuf field: algorithm.posture.LicenseInfoResult license_info = 1
     */
    licenseInfo?: LicenseInfoResult;
}
/**
 * @generated from protobuf message algorithm.posture.GetPostureReportHeaderListRequest
 */
export interface GetPostureReportHeaderListRequest {
    /**
     * @generated from protobuf field: repeated string uuids = 1
     */
    uuids: string[];
    /**
     * @generated from protobuf field: google.protobuf.BoolValue isSave = 2
     */
    isSave?: BoolValue; // 是否保存
    /**
     * @generated from protobuf field: google.protobuf.StringValue language = 3
     */
    language?: StringValue;
}
/**
 * @generated from protobuf message algorithm.posture.GetPostureReportHeaderListResponse
 */
export interface GetPostureReportHeaderListResponse {
    /**
     * @generated from protobuf field: repeated algorithm.posture.PostureReportHeader postureReportHeaders = 1
     */
    postureReportHeaders: PostureReportHeader[];
}
/**
 * @generated from protobuf message algorithm.posture.PostureReportHeader
 */
export interface PostureReportHeader {
    /**
     * @generated from protobuf field: google.protobuf.StringValue uuid = 1
     */
    uuid?: StringValue;
    /**
     * @generated from protobuf field: google.protobuf.StringValue front = 2
     */
    front?: StringValue;
    /**
     * @generated from protobuf field: google.protobuf.StringValue side = 3
     */
    side?: StringValue;
    /**
     * @generated from protobuf field: google.protobuf.StringValue back = 4
     */
    back?: StringValue;
    /**
     * @generated from protobuf field: google.protobuf.Int64Value organizationId = 5
     */
    organizationId?: Int64Value;
    /**
     * @generated from protobuf field: google.protobuf.StringValue status = 6
     */
    status?: StringValue;
    /**
     * @generated from protobuf field: google.protobuf.StringValue resultPosture = 7
     */
    resultPosture?: StringValue;
    /**
     * @generated from protobuf field: google.protobuf.BoolValue success = 8
     */
    success?: BoolValue;
    /**
     * @generated from protobuf field: google.protobuf.Int64Value postureTimestamp = 9
     */
    postureTimestamp?: Int64Value;
    /**
     * @generated from protobuf field: google.protobuf.Int64Value accountId = 10
     */
    accountId?: Int64Value;
    /**
     * 报告分享地址
     *
     * @generated from protobuf field: google.protobuf.StringValue urlForShare = 11
     */
    urlForShare?: StringValue;
    /**
     * 报告本地查看地址
     *
     * @generated from protobuf field: google.protobuf.StringValue urlForLocal = 12
     */
    urlForLocal?: StringValue;
}
/**
 * @generated from protobuf message algorithm.posture.GetLicenseInfoByAccountIdsRequest
 */
export interface GetLicenseInfoByAccountIdsRequest {
    /**
     * @generated from protobuf field: repeated int64 accountIds = 1
     */
    accountIds: string[];
}
/**
 * @generated from protobuf message algorithm.posture.GetLicenseInfoByAccountIdsResponse
 */
export interface GetLicenseInfoByAccountIdsResponse {
    /**
     * @generated from protobuf field: repeated algorithm.posture.LicenseInfoResult licenseInfoResults = 1
     */
    licenseInfoResults: LicenseInfoResult[];
}
/**
 * @generated from protobuf message algorithm.posture.GetLicenseInfoRequest
 */
export interface GetLicenseInfoRequest {
}
/**
 * @generated from protobuf message algorithm.posture.GetLicenseInfoResponse
 */
export interface GetLicenseInfoResponse {
    /**
     * @generated from protobuf field: repeated algorithm.posture.LicenseInfoResult licenseInfoResults = 1
     */
    licenseInfoResults: LicenseInfoResult[];
}
/**
 * @generated from protobuf message algorithm.posture.LicenseInfoResult
 */
export interface LicenseInfoResult {
    /**
     * @generated from protobuf field: google.protobuf.Int64Value organizationId = 1
     */
    organizationId?: Int64Value;
    /**
     * @generated from protobuf field: google.protobuf.Int64Value endTimestamp = 2
     */
    endTimestamp?: Int64Value;
    /**
     * @generated from protobuf field: google.protobuf.Int64Value count = 3
     */
    count?: Int64Value;
    /**
     * @generated from protobuf field: google.protobuf.Int64Value accountId = 4
     */
    accountId?: Int64Value;
    /**
     * @generated from protobuf field: google.protobuf.Int64Value totalCount = 5
     */
    totalCount?: Int64Value;
}
/**
 * @generated from protobuf message algorithm.posture.UpdatePostureReportCoordinateResponse
 */
export interface UpdatePostureReportCoordinateResponse {
    /**
     * @generated from protobuf field: bool isUpdated = 1
     */
    isUpdated: boolean;
}
/**
 * @generated from protobuf message algorithm.posture.UpdatePostureReportCoordinateRequest
 */
export interface UpdatePostureReportCoordinateRequest {
    /**
     * @generated from protobuf field: algorithm.posture.PointsResult front = 1
     */
    front?: PointsResult;
    /**
     * @generated from protobuf field: algorithm.posture.PointsResult side = 2
     */
    side?: PointsResult;
    /**
     * @generated from protobuf field: string uuid = 3
     */
    uuid: string;
    /**
     * @generated from protobuf field: algorithm.posture.PointsResult back = 4
     */
    back?: PointsResult;
    /**
     * @generated from protobuf field: algorithm.posture.PointsResult other_side = 5
     */
    otherSide?: PointsResult;
}
/**
 * @generated from protobuf message algorithm.posture.GetMuscleStateRequest
 */
export interface GetMuscleStateRequest {
    /**
     * @generated from protobuf field: repeated algorithm.posture.GetMuscleStateRequest.MuscleStateQuery muscleStateQuery = 1
     */
    muscleStateQuery: GetMuscleStateRequest_MuscleStateQuery[];
    /**
     * @generated from protobuf field: string lang = 2
     */
    lang: string;
}
/**
 * @generated from protobuf message algorithm.posture.GetMuscleStateRequest.MuscleStateQuery
 */
export interface GetMuscleStateRequest_MuscleStateQuery {
    /**
     * @generated from protobuf field: string key = 1
     */
    key: string;
    /**
     * @generated from protobuf field: algorithm.posture.Side direction = 2
     */
    direction: Side;
    /**
     * @generated from protobuf field: algorithm.posture.Level level = 3
     */
    level: Level;
}
/**
 * @generated from protobuf message algorithm.posture.GetMuscleStateResponse
 */
export interface GetMuscleStateResponse {
    /**
     * @generated from protobuf field: repeated algorithm.posture.GetMuscleStateResponse.MuscleStateResult muscleStateResults = 1
     */
    muscleStateResults: GetMuscleStateResponse_MuscleStateResult[];
}
/**
 * @generated from protobuf message algorithm.posture.GetMuscleStateResponse.MuscleStateResult
 */
export interface GetMuscleStateResponse_MuscleStateResult {
    /**
     * @generated from protobuf field: int32 muscleStateId = 1
     */
    muscleStateId: number;
    /**
     * @generated from protobuf field: int32 detailId = 2
     */
    detailId: number;
    /**
     * @generated from protobuf field: string key = 3
     */
    key: string;
    /**
     * @generated from protobuf field: algorithm.posture.Side direction = 4
     */
    direction: Side;
    /**
     * @generated from protobuf field: algorithm.posture.Level level = 5
     */
    level: Level;
    /**
     * @generated from protobuf field: string name = 6
     */
    name: string;
    /**
     * @generated from protobuf field: string image = 7
     */
    image: string;
    /**
     * @generated from protobuf field: repeated algorithm.posture.GetMuscleStateResponse.DiseaseMuscleResult diseaseMuscleResults = 8
     */
    diseaseMuscleResults: GetMuscleStateResponse_DiseaseMuscleResult[];
    /**
     * @generated from protobuf field: repeated algorithm.posture.GetMuscleStateResponse.DiseaseParts diseaseParts = 9
     */
    diseaseParts: GetMuscleStateResponse_DiseaseParts[];
}
/**
 * @generated from protobuf message algorithm.posture.GetMuscleStateResponse.DiseaseMuscleResult
 */
export interface GetMuscleStateResponse_DiseaseMuscleResult {
    /**
     * @generated from protobuf field: int32 diseaseMuscleId = 1
     */
    diseaseMuscleId: number;
    /**
     * @generated from protobuf field: int32 detailId = 2
     */
    detailId: number;
    /**
     * @generated from protobuf field: algorithm.posture.GetMuscleStateResponse.MuscleResult muscleResult = 3
     */
    muscleResult?: GetMuscleStateResponse_MuscleResult;
    /**
     * @generated from protobuf field: algorithm.posture.Side side = 4
     */
    side: Side;
    /**
     * @generated from protobuf field: algorithm.posture.GetMuscleStateResponse.Status status = 5
     */
    status: GetMuscleStateResponse_Status;
    /**
     * @generated from protobuf field: string description = 6
     */
    description: string;
}
/**
 * @generated from protobuf message algorithm.posture.GetMuscleStateResponse.DiseaseParts
 */
export interface GetMuscleStateResponse_DiseaseParts {
    /**
     * @generated from protobuf field: int32 diseasePartsId = 1
     */
    diseasePartsId: number;
    /**
     * @generated from protobuf field: int32 muscleStateId = 2
     */
    muscleStateId: number;
    /**
     * @generated from protobuf field: algorithm.posture.Side side = 3
     */
    side: Side;
    /**
     * @generated from protobuf field: string description = 5
     */
    description: string;
    /**
     * @generated from protobuf field: string image = 6
     */
    image: string;
    /**
     * @generated from protobuf field: algorithm.posture.GetMuscleStateResponse.Parts parts = 7
     */
    parts?: GetMuscleStateResponse_Parts;
}
/**
 * @generated from protobuf message algorithm.posture.GetMuscleStateResponse.MuscleResult
 */
export interface GetMuscleStateResponse_MuscleResult {
    /**
     * @generated from protobuf field: int32 muscleId = 1
     */
    muscleId: number;
    /**
     * @generated from protobuf field: string muscleKey = 2
     */
    muscleKey: string;
    /**
     * @generated from protobuf field: string name = 3
     */
    name: string;
}
/**
 * @generated from protobuf message algorithm.posture.GetMuscleStateResponse.Parts
 */
export interface GetMuscleStateResponse_Parts {
    /**
     * @generated from protobuf field: int32 partsId = 1
     */
    partsId: number;
    /**
     * @generated from protobuf field: string partsKey = 2
     */
    partsKey: string;
    /**
     * @generated from protobuf field: string name = 3
     */
    name: string;
}
/**
 * @generated from protobuf enum algorithm.posture.GetMuscleStateResponse.Status
 */
export enum GetMuscleStateResponse_Status {
    /**
     * @generated from protobuf enum value: Status_zero = 0;
     */
    Status_zero = 0,
    /**
     * @generated from protobuf enum value: Weak = 1;
     */
    Weak = 1,
    /**
     * @generated from protobuf enum value: Tension = 2;
     */
    Tension = 2
}
/**
 * @generated from protobuf message algorithm.posture.GetPostureReportListRequest
 */
export interface GetPostureReportListRequest {
    /**
     * @generated from protobuf field: repeated string uuid = 1
     */
    uuid: string[];
    /**
     * @generated from protobuf field: string language = 2
     */
    language: string; // 语言，不传默认中文「zh」
    /**
     * @generated from protobuf field: google.protobuf.Int64Value organizationId = 3
     */
    organizationId?: Int64Value;
    /**
     * @generated from protobuf field: google.protobuf.BoolValue isSave = 4
     */
    isSave?: BoolValue; // 是否保存
}
/**
 * @generated from protobuf message algorithm.posture.GetPostureReportListResponse
 */
export interface GetPostureReportListResponse {
    /**
     * @generated from protobuf field: repeated algorithm.posture.GetPostureReportResponse postureReportList = 1
     */
    postureReportList: GetPostureReportResponse[];
}
/**
 * @generated from protobuf message algorithm.posture.GetReportHeaderRequest
 */
export interface GetReportHeaderRequest {
    /**
     * @generated from protobuf field: string uuid = 1
     */
    uuid: string;
    /**
     * @generated from protobuf field: google.protobuf.StringValue language = 2
     */
    language?: StringValue;
    /**
     * @generated from protobuf field: google.protobuf.BoolValue editable = 3
     */
    editable?: BoolValue;
}
/**
 * @generated from protobuf message algorithm.posture.ReportHeader
 */
export interface ReportHeader {
    /**
     * @generated from protobuf field: string uuid = 1
     */
    uuid: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp create_time = 2
     */
    createTime?: Timestamp;
    /**
     * @generated from protobuf field: string process_status = 3
     */
    processStatus: string;
    /**
     * @generated from protobuf field: string report_url = 6
     */
    reportUrl: string;
    /**
     * @generated from protobuf field: algorithm.posture.ReportHeader.Examinee examinee = 7
     */
    examinee?: ReportHeader_Examinee;
}
/**
 * @generated from protobuf message algorithm.posture.ReportHeader.Examinee
 */
export interface ReportHeader_Examinee {
    /**
     * @generated from protobuf field: google.protobuf.StringValue name = 1
     */
    name?: StringValue;
    /**
     * @generated from protobuf field: google.protobuf.StringValue gender = 2
     */
    gender?: StringValue;
    /**
     * @generated from protobuf field: google.protobuf.Int32Value age = 3
     */
    age?: Int32Value;
    /**
     * @generated from protobuf field: google.protobuf.Int32Value height = 4
     */
    height?: Int32Value;
    /**
     * @generated from protobuf field: google.protobuf.Int32Value weight = 5
     */
    weight?: Int32Value;
    /**
     * @generated from protobuf field: google.protobuf.StringValue description = 6
     */
    description?: StringValue;
    /**
     * @generated from protobuf field: google.protobuf.StringValue phone_number = 10
     */
    phoneNumber?: StringValue;
    /**
     * @generated from protobuf field: google.protobuf.StringValue id_number = 11
     */
    idNumber?: StringValue;
}
/**
 * @generated from protobuf message algorithm.posture.FacePoints
 */
export interface FacePoints {
    /**
     * 鼻子坐标点
     *
     * @generated from protobuf field: algorithm.posture.PointResult nose = 1
     */
    nose?: PointResult;
    /**
     * 眼睛坐标点
     *
     * @generated from protobuf field: algorithm.posture.PartResult eye = 9
     */
    eye?: PartResult;
    /**
     * 耳朵坐标点
     *
     * @generated from protobuf field: algorithm.posture.PartResult ear = 10
     */
    ear?: PartResult;
}
/**
 * @generated from protobuf message algorithm.posture.CosSecretResult
 */
export interface CosSecretResult {
    /**
     * 临时secretId
     *
     * @generated from protobuf field: google.protobuf.StringValue secretId = 1
     */
    secretId?: StringValue;
    /**
     * 临时secretKey
     *
     * @generated from protobuf field: google.protobuf.StringValue secretKey = 2
     */
    secretKey?: StringValue;
    /**
     * sessionToken
     *
     * @generated from protobuf field: google.protobuf.StringValue sessionToken = 3
     */
    sessionToken?: StringValue;
    /**
     * 过期时间
     *
     * @generated from protobuf field: google.protobuf.Int64Value expirationTime = 4
     */
    expirationTime?: Int64Value;
}
/**
 * @generated from protobuf message algorithm.posture.ResourceHandleResult
 */
export interface ResourceHandleResult {
    /**
     * @generated from protobuf field: google.protobuf.StringValue bucket = 1
     */
    bucket?: StringValue;
    /**
     * @generated from protobuf field: google.protobuf.StringValue region = 2
     */
    region?: StringValue;
    /**
     * @generated from protobuf field: google.protobuf.StringValue frontKey = 3
     */
    frontKey?: StringValue;
    /**
     * @generated from protobuf field: google.protobuf.StringValue sideKey = 4
     */
    sideKey?: StringValue;
    /**
     * @generated from protobuf field: google.protobuf.StringValue bucketUrl = 5
     */
    bucketUrl?: StringValue;
    /**
     * @generated from protobuf field: algorithm.posture.CosSecretResult cosSecretResult = 6
     */
    cosSecretResult?: CosSecretResult;
}
/**
 * @generated from protobuf message algorithm.posture.IssueLicenseRequest
 */
export interface IssueLicenseRequest {
    /**
     * 组织id
     *
     * @generated from protobuf field: int64 organizationId = 1
     */
    organizationId: string;
    /**
     * 增加的天数
     *
     * @generated from protobuf field: int32 day = 2
     */
    day: number;
    /**
     * 次数
     *
     * @generated from protobuf field: int64 count = 3
     */
    count: string;
}
/**
 * @generated from protobuf message algorithm.posture.IssueLicenseResponse
 */
export interface IssueLicenseResponse {
    /**
     * 许可证id
     *
     * @generated from protobuf field: int64 licenseId = 1
     */
    licenseId: string;
}
/**
 * @generated from protobuf message algorithm.posture.IssueOrganizationLicenseRequest
 */
export interface IssueOrganizationLicenseRequest {
    /**
     * @generated from protobuf field: int64 organization_id = 1
     */
    organizationId: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp expired_at = 2
     */
    expiredAt?: Timestamp;
    /**
     * @generated from protobuf field: int32 times = 3
     */
    times: number;
    /**
     * @deprecated
     * @generated from protobuf field: google.protobuf.StringValue client = 4 [deprecated = true]
     */
    client?: StringValue;
}
/**
 * @generated from protobuf message algorithm.posture.IssueOrganizationLicenseResponse
 */
export interface IssueOrganizationLicenseResponse {
    /**
     * @generated from protobuf field: int64 license_id = 1
     */
    licenseId: string;
}
/**
 * @generated from protobuf message algorithm.posture.IssueAccountLicenseRequest
 */
export interface IssueAccountLicenseRequest {
    /**
     * 增加的天数
     *
     * @generated from protobuf field: int32 day = 2
     */
    day: number;
    /**
     * 次数
     *
     * @generated from protobuf field: int64 count = 3
     */
    count: string;
    /**
     * accountId
     *
     * @generated from protobuf field: int64 accountId = 4
     */
    accountId: string;
    /**
     * @generated from protobuf field: google.protobuf.StringValue client = 5
     */
    client?: StringValue;
}
/**
 * @generated from protobuf message algorithm.posture.IssueAccountLicenseResponse
 */
export interface IssueAccountLicenseResponse {
    /**
     * 许可证id
     *
     * @generated from protobuf field: int64 licenseId = 1
     */
    licenseId: string;
}
/**
 * @generated from protobuf message algorithm.posture.GetRiskDetailByRiskIdsResponse
 */
export interface GetRiskDetailByRiskIdsResponse {
    /**
     * 风险详情列表
     *
     * @generated from protobuf field: repeated algorithm.posture.RiskDetailResult riskDetailResults = 1
     */
    riskDetailResults: RiskDetailResult[];
}
/**
 * @generated from protobuf message algorithm.posture.RiskDetailResult
 */
export interface RiskDetailResult {
    /**
     * 风险Id
     *
     * @generated from protobuf field: int32 riskId = 1
     */
    riskId: number;
    /**
     * 训练方法
     *
     * @generated from protobuf field: repeated algorithm.posture.TagResult trainings = 9
     */
    trainings: TagResult[];
    /**
     * 注意事项
     *
     * @generated from protobuf field: repeated algorithm.posture.TagResult attentions = 10
     */
    attentions: TagResult[];
    /**
     * 原因
     *
     * @generated from protobuf field: repeated algorithm.posture.ResultResult reasons = 11
     */
    reasons: ResultResult[];
    /**
     * 风险描述
     *
     * @generated from protobuf field: repeated algorithm.posture.ResultResult risks = 12
     */
    risks: ResultResult[];
}
/**
 * @generated from protobuf message algorithm.posture.GetRiskDetailByRiskIdsRequest
 */
export interface GetRiskDetailByRiskIdsRequest {
    /**
     * 风险详情对象列表 RiskDetailInfo中只传riskId即可
     *
     * @generated from protobuf field: repeated algorithm.posture.RiskDetailInfo riskDetailInfos = 1
     */
    riskDetailInfos: RiskDetailInfo[];
    /**
     * 国际化
     *
     * @generated from protobuf field: string language = 2
     */
    language: string;
    /**
     * 组织Id
     *
     * @generated from protobuf field: google.protobuf.Int64Value organizationId = 3
     */
    organizationId?: Int64Value;
}
/**
 * @generated from protobuf message algorithm.posture.RiskDetailInfo
 */
export interface RiskDetailInfo {
    /**
     * 风险Id
     *
     * @generated from protobuf field: int32 riskId = 1
     */
    riskId: number;
    /**
     * 风险名
     *
     * @generated from protobuf field: string riskName = 2
     */
    riskName: string;
}
/**
 * @generated from protobuf message algorithm.posture.UploadPostureCallbackRequest
 */
export interface UploadPostureCallbackRequest {
    /**
     * @generated from protobuf field: int32 code = 2
     */
    code: number;
    /**
     * 报告uuid
     *
     * @generated from protobuf field: string id = 1
     */
    id: string;
    /**
     * 是否成功
     *    bool success = 2;
     * 报告内容
     *    BodyReplyResult body = 3;
     *
     * @generated from protobuf field: string message = 4
     */
    message: string;
}
/**
 * @generated from protobuf message algorithm.posture.BodyReplyResult
 */
export interface BodyReplyResult {
    /**
     * @generated from protobuf field: string uuid = 1
     */
    uuid: string;
    /**
     * @generated from protobuf field: algorithm.posture.ConclusionReplyResult front = 2
     */
    front?: ConclusionReplyResult;
    /**
     * @generated from protobuf field: algorithm.posture.ConclusionReplyResult side = 4
     */
    side?: ConclusionReplyResult;
}
/**
 * @generated from protobuf message algorithm.posture.ConclusionReplyResult
 */
export interface ConclusionReplyResult {
    /**
     * @generated from protobuf field: bool valid = 1
     */
    valid: boolean; // 是否有效
    /**
     * @generated from protobuf field: string cause = 2
     */
    cause: string; // 无效原因
    /**
     * @generated from protobuf field: algorithm.posture.PointsResult body = 3
     */
    body?: PointsResult; // 身体部位坐标
    /**
     * @generated from protobuf field: algorithm.posture.ConclusionReplyResult.ShootingAngle angle = 4
     */
    angle: ConclusionReplyResult_ShootingAngle; // 拍摄视角
    /**
     * @generated from protobuf field: repeated algorithm.posture.RiskReplyResult risks = 5
     */
    risks: RiskReplyResult[]; // 风险
}
/**
 * @generated from protobuf enum algorithm.posture.ConclusionReplyResult.ShootingAngle
 */
export enum ConclusionReplyResult_ShootingAngle {
    /**
     * @generated from protobuf enum value: angle_zero = 0;
     */
    angle_zero = 0,
    /**
     * @generated from protobuf enum value: angle_front = 1;
     */
    angle_front = 1,
    /**
     * @generated from protobuf enum value: angle_back = 2;
     */
    angle_back = 2,
    /**
     * @generated from protobuf enum value: angle_left = 3;
     */
    angle_left = 3,
    /**
     * @generated from protobuf enum value: angle_right = 4;
     */
    angle_right = 4
}
/**
 * @generated from protobuf message algorithm.posture.RiskReplyResult
 */
export interface RiskReplyResult {
    /**
     * @generated from protobuf field: bool valid = 1
     */
    valid: boolean; // 是否有效
    /**
     * @generated from protobuf field: string key = 2
     */
    key: string;
    /**
     * @generated from protobuf field: string name = 3
     */
    name: string; // 名称
    /**
     * @generated from protobuf field: double measurement = 4
     */
    measurement: number; // 衡量指标
    /**
     * @generated from protobuf field: double score = 5
     */
    score: number; // 风险值
    /**
     * @generated from protobuf field: algorithm.posture.Level level = 6
     */
    level: Level; // 风险级别
    /**
     * @generated from protobuf field: string description = 7
     */
    description: string; // 风险说明
    /**
     * @generated from protobuf field: string supplement = 8
     */
    supplement: string; // 补充说明，比如：高低肩，有头部侧倾风险（右倾），虽然这里已经说明，不免有些地方还要单独使用侧倾的情况
    /**
     * @generated from protobuf field: algorithm.posture.Side side = 9
     */
    side: Side; // 当描述侧倾类风险时，表示向哪一侧倾斜，比如：高低肩side = LEFT，表示左倾，左低右高
}
/**
 * @generated from protobuf message algorithm.posture.BodyResult
 */
export interface BodyResult {
    /**
     * 正面
     *
     * @generated from protobuf field: algorithm.posture.ItemResult front = 3
     */
    front?: ItemResult;
    /**
     * 侧面
     *
     * @generated from protobuf field: algorithm.posture.ItemResult side = 4
     */
    side?: ItemResult;
    /**
     * 背面
     *
     * @generated from protobuf field: algorithm.posture.ItemResult back = 5
     */
    back?: ItemResult;
    /**
     * 另一个侧面
     *
     * @generated from protobuf field: algorithm.posture.ItemResult other_side = 6
     */
    otherSide?: ItemResult;
}
/**
 * @generated from protobuf message algorithm.posture.UploadPostureCallbackResponse
 */
export interface UploadPostureCallbackResponse {
    /**
     *    是否成功
     *
     * @generated from protobuf field: bool success = 1
     */
    success: boolean;
}
/**
 * @generated from protobuf message algorithm.posture.UploadPostureRequest
 */
export interface UploadPostureRequest {
    /**
     * @generated from protobuf field: string frontKey = 1
     */
    frontKey: string;
    /**
     * @generated from protobuf field: string sideKey = 2
     */
    sideKey: string;
    /**
     * @generated from protobuf field: string bucketUrl = 3
     */
    bucketUrl: string;
    /**
     * @generated from protobuf field: google.protobuf.StringValue backKey = 4
     */
    backKey?: StringValue;
    /**
     * @generated from protobuf field: google.protobuf.Int64Value organizationId = 5
     */
    organizationId?: Int64Value;
    /**
     * @generated from protobuf field: google.protobuf.StringValue client = 6
     */
    client?: StringValue;
    /**
     * @generated from protobuf field: google.protobuf.StringValue other_side_key = 7
     */
    otherSideKey?: StringValue;
    /**
     * @generated from protobuf field: google.protobuf.DoubleValue max_atr_angle = 11
     */
    maxAtrAngle?: DoubleValue;
    /**
     * @generated from protobuf field: algorithm.posture.PartResult back_heel = 12
     */
    backHeel?: PartResult; // 背面拍摄的左右足跟
    /**
     * @generated from protobuf field: repeated algorithm.posture.UploadPostureRequest.DepthData depth_data = 13
     */
    depthData: UploadPostureRequest_DepthData[];
}
/**
 * @generated from protobuf message algorithm.posture.UploadPostureRequest.DepthData
 */
export interface UploadPostureRequest_DepthData {
    /**
     * @generated from protobuf field: string shooting_angle = 1
     */
    shootingAngle: string; // options: front, back, side, otherside, side对应sideKey的2d图片，otherside对应other_side_key的2d图片
    /**
     * @generated from protobuf field: algorithm.posture.UploadPostureRequest.Intrinsics intrinsics = 2
     */
    intrinsics?: UploadPostureRequest_Intrinsics;
    /**
     * @generated from protobuf field: google.protobuf.StringValue depth_image_key = 3
     */
    depthImageKey?: StringValue;
    /**
     * @generated from protobuf field: google.protobuf.StringValue contour_map_moire_image_key = 4
     */
    contourMapMoireImageKey?: StringValue;
}
/**
 * @generated from protobuf message algorithm.posture.UploadPostureRequest.Intrinsics
 */
export interface UploadPostureRequest_Intrinsics {
    /**
     * @generated from protobuf field: double fx = 1
     */
    fx: number;
    /**
     * @generated from protobuf field: double fy = 2
     */
    fy: number;
    /**
     * @generated from protobuf field: double cx = 3
     */
    cx: number;
    /**
     * @generated from protobuf field: double cy = 4
     */
    cy: number;
}
/**
 * @generated from protobuf message algorithm.posture.UploadPostureResponse
 */
export interface UploadPostureResponse {
    /**
     * 返回的报告uuid
     *
     * @generated from protobuf field: string uuid = 1
     */
    uuid: string;
}
/**
 * @generated from protobuf message algorithm.posture.GetPostureReportRequest
 */
export interface GetPostureReportRequest {
    /**
     * 报告uuid
     *
     * @generated from protobuf field: string uuid = 1
     */
    uuid: string;
    /**
     * 国际化
     *
     * @generated from protobuf field: string language = 2
     */
    language: string;
    /**
     * 组织id
     *
     * @generated from protobuf field: google.protobuf.Int64Value organizationId = 3
     */
    organizationId?: Int64Value;
}
/**
 * @generated from protobuf message algorithm.posture.GetPostureReportResponse
 */
export interface GetPostureReportResponse {
    /**
     * @generated from protobuf field: string uuid = 1
     */
    uuid: string;
    /**
     * 正面照
     *
     * @generated from protobuf field: google.protobuf.StringValue front = 2
     */
    front?: StringValue;
    /**
     * 侧面照
     *
     * @generated from protobuf field: google.protobuf.StringValue side = 3
     */
    side?: StringValue;
    /**
     * 是否成功
     *
     * @generated from protobuf field: google.protobuf.BoolValue success = 4
     */
    success?: BoolValue;
    /**
     * 具体数据
     *
     * @generated from protobuf field: algorithm.posture.BodyResult body = 5
     */
    body?: BodyResult;
    /**
     * 报告生成状态 PROCESSING进行中 COMPLETED 完成
     *
     * @generated from protobuf field: google.protobuf.StringValue status = 6
     */
    status?: StringValue;
    /**
     * 报告结果状态 NULL生成中 OK  INVALID_FRONT正面无效 INVALID_SIDE侧面无效 INVALID全部无效
     *
     * @generated from protobuf field: google.protobuf.StringValue resultPosture = 7
     */
    resultPosture?: StringValue;
    /**
     * 通用结果
     *
     * @generated from protobuf field: algorithm.posture.GeneralResult general = 8
     */
    general?: GeneralResult;
    /**
     * 训练方法
     *
     * @generated from protobuf field: repeated algorithm.posture.TagResult trainings = 9
     */
    trainings: TagResult[];
    /**
     * 注意事项
     *
     * @generated from protobuf field: repeated algorithm.posture.TagResult attentions = 10
     */
    attentions: TagResult[];
    /**
     * 原因
     *
     * @generated from protobuf field: repeated algorithm.posture.ResultResult reasons = 11
     */
    reasons: ResultResult[];
    /**
     * 风险描述
     *
     * @generated from protobuf field: repeated algorithm.posture.ResultResult risks = 12
     */
    risks: ResultResult[];
    /**
     * 背面
     *
     * @generated from protobuf field: google.protobuf.StringValue back = 13
     */
    back?: StringValue;
    /**
     * 另一个侧面，之前的数据中，side拍摄的都是右面，这里基本可以特指左面
     *
     * @generated from protobuf field: google.protobuf.StringValue other_side = 14
     */
    otherSide?: StringValue;
    /**
     * 报告分享地址
     *
     * @generated from protobuf field: google.protobuf.StringValue urlForShare = 16
     */
    urlForShare?: StringValue;
    /**
     * 报告本地查看地址
     *
     * @generated from protobuf field: google.protobuf.StringValue urlForLocal = 17
     */
    urlForLocal?: StringValue;
    /**
     * @generated from protobuf field: google.protobuf.DoubleValue max_atr_angle = 21
     */
    maxAtrAngle?: DoubleValue;
    /**
     * @generated from protobuf field: repeated algorithm.posture.GetPostureReportResponse.DepthData depth_data = 22
     */
    depthData: GetPostureReportResponse_DepthData[];
}
/**
 * @generated from protobuf message algorithm.posture.GetPostureReportResponse.DepthData
 */
export interface GetPostureReportResponse_DepthData {
    /**
     * @generated from protobuf field: string shooting_angle = 1
     */
    shootingAngle: string;
    /**
     * @generated from protobuf field: algorithm.posture.GetPostureReportResponse.Keypoints keypoints = 2
     */
    keypoints?: GetPostureReportResponse_Keypoints;
    /**
     * @generated from protobuf field: google.protobuf.StringValue contour_map_moire_image_url = 4
     */
    contourMapMoireImageUrl?: StringValue;
}
/**
 * @generated from protobuf message algorithm.posture.GetPostureReportResponse.Keypoints
 */
export interface GetPostureReportResponse_Keypoints {
    /**
     * @generated from protobuf field: algorithm.posture.GetPostureReportResponse.Point nose = 1
     */
    nose?: GetPostureReportResponse_Point;
    /**
     * @generated from protobuf field: algorithm.posture.GetPostureReportResponse.Point neck = 2
     */
    neck?: GetPostureReportResponse_Point;
    /**
     * @generated from protobuf field: algorithm.posture.GetPostureReportResponse.Point left_shoulder = 3
     */
    leftShoulder?: GetPostureReportResponse_Point;
    /**
     * @generated from protobuf field: algorithm.posture.GetPostureReportResponse.Point right_shoulder = 4
     */
    rightShoulder?: GetPostureReportResponse_Point;
    /**
     * @generated from protobuf field: algorithm.posture.GetPostureReportResponse.Point left_elbow = 5
     */
    leftElbow?: GetPostureReportResponse_Point;
    /**
     * @generated from protobuf field: algorithm.posture.GetPostureReportResponse.Point right_elbow = 6
     */
    rightElbow?: GetPostureReportResponse_Point;
    /**
     * @generated from protobuf field: algorithm.posture.GetPostureReportResponse.Point left_wrist = 7
     */
    leftWrist?: GetPostureReportResponse_Point;
    /**
     * @generated from protobuf field: algorithm.posture.GetPostureReportResponse.Point right_wrist = 8
     */
    rightWrist?: GetPostureReportResponse_Point;
    /**
     * @generated from protobuf field: algorithm.posture.GetPostureReportResponse.Point left_hip = 9
     */
    leftHip?: GetPostureReportResponse_Point;
    /**
     * @generated from protobuf field: algorithm.posture.GetPostureReportResponse.Point right_hip = 10
     */
    rightHip?: GetPostureReportResponse_Point;
    /**
     * @generated from protobuf field: algorithm.posture.GetPostureReportResponse.Point left_knee = 11
     */
    leftKnee?: GetPostureReportResponse_Point;
    /**
     * @generated from protobuf field: algorithm.posture.GetPostureReportResponse.Point right_knee = 12
     */
    rightKnee?: GetPostureReportResponse_Point;
    /**
     * @generated from protobuf field: algorithm.posture.GetPostureReportResponse.Point left_ankle = 13
     */
    leftAnkle?: GetPostureReportResponse_Point;
    /**
     * @generated from protobuf field: algorithm.posture.GetPostureReportResponse.Point right_ankle = 14
     */
    rightAnkle?: GetPostureReportResponse_Point;
    /**
     * @generated from protobuf field: algorithm.posture.GetPostureReportResponse.Point left_eye = 15
     */
    leftEye?: GetPostureReportResponse_Point;
    /**
     * @generated from protobuf field: algorithm.posture.GetPostureReportResponse.Point right_eye = 16
     */
    rightEye?: GetPostureReportResponse_Point;
    /**
     * @generated from protobuf field: algorithm.posture.GetPostureReportResponse.Point left_ear = 17
     */
    leftEar?: GetPostureReportResponse_Point;
    /**
     * @generated from protobuf field: algorithm.posture.GetPostureReportResponse.Point right_ear = 18
     */
    rightEar?: GetPostureReportResponse_Point;
    /**
     * @generated from protobuf field: algorithm.posture.GetPostureReportResponse.Point left_heel = 19
     */
    leftHeel?: GetPostureReportResponse_Point;
    /**
     * @generated from protobuf field: algorithm.posture.GetPostureReportResponse.Point right_heel = 20
     */
    rightHeel?: GetPostureReportResponse_Point;
}
/**
 * @generated from protobuf message algorithm.posture.GetPostureReportResponse.Point
 */
export interface GetPostureReportResponse_Point {
    /**
     * @generated from protobuf field: double x = 1
     */
    x: number;
    /**
     * @generated from protobuf field: double y = 2
     */
    y: number;
    /**
     * @generated from protobuf field: double z = 3
     */
    z: number;
}
/**
 * @generated from protobuf message algorithm.posture.GeneralResult
 */
export interface GeneralResult {
    /**
     * 分数
     *
     * @generated from protobuf field: double score = 1
     */
    score: number;
    /**
     * 程度
     *
     * @generated from protobuf field: string level = 2
     */
    level: string;
    /**
     * 全国百分比
     *
     * @generated from protobuf field: double percent = 3
     */
    percent: number;
}
/**
 * @generated from protobuf message algorithm.posture.ItemResult
 */
export interface ItemResult {
    /**
     * 是否有效
     *
     * @generated from protobuf field: bool valid = 1
     */
    valid: boolean;
    /**
     * 坐标点列表
     *
     * @generated from protobuf field: algorithm.posture.PointsResult points = 2
     */
    points?: PointsResult;
    /**
     * @generated from protobuf field: google.protobuf.StringValue side = 3
     */
    side?: StringValue;
    /**
     * 风险列表
     *
     * @generated from protobuf field: repeated algorithm.posture.RiskResult risks = 4
     */
    risks: RiskResult[];
}
/**
 * @generated from protobuf message algorithm.posture.PointsResult
 */
export interface PointsResult {
    /**
     * 鼻子坐标点
     *
     * @generated from protobuf field: algorithm.posture.PointResult nose = 1
     */
    nose?: PointResult;
    /**
     * 脖子坐标点
     *
     * @generated from protobuf field: algorithm.posture.PointResult neck = 2
     */
    neck?: PointResult;
    /**
     * 肩膀坐标点
     *
     * @generated from protobuf field: algorithm.posture.PartResult shoulder = 3
     */
    shoulder?: PartResult;
    /**
     * 肘部坐标点
     *
     * @generated from protobuf field: algorithm.posture.PartResult elbow = 4
     */
    elbow?: PartResult;
    /**
     * 手腕坐标点
     *
     * @generated from protobuf field: algorithm.posture.PartResult wrist = 5
     */
    wrist?: PartResult;
    /**
     * 臀部坐标点
     *
     * @generated from protobuf field: algorithm.posture.PartResult hip = 6
     */
    hip?: PartResult;
    /**
     * 膝坐标点
     *
     * @generated from protobuf field: algorithm.posture.PartResult knee = 7
     */
    knee?: PartResult;
    /**
     * 踝坐标点
     *
     * @generated from protobuf field: algorithm.posture.PartResult ankle = 8
     */
    ankle?: PartResult;
    /**
     * 眼睛坐标点
     *
     * @generated from protobuf field: algorithm.posture.PartResult eye = 9
     */
    eye?: PartResult;
    /**
     * 耳朵坐标点
     *
     * @generated from protobuf field: algorithm.posture.PartResult ear = 10
     */
    ear?: PartResult;
    /**
     * 足跟坐标点
     *
     * @generated from protobuf field: algorithm.posture.PartResult heel = 11
     */
    heel?: PartResult;
}
/**
 * @generated from protobuf message algorithm.posture.PartResult
 */
export interface PartResult {
    /**
     * 左边的坐标点
     *
     * @generated from protobuf field: algorithm.posture.PointResult left = 1
     */
    left?: PointResult;
    /**
     * 右边的坐标点
     *
     * @generated from protobuf field: algorithm.posture.PointResult right = 2
     */
    right?: PointResult;
}
/**
 * @generated from protobuf message algorithm.posture.PointResult
 */
export interface PointResult {
    /**
     * @generated from protobuf field: double x = 1
     */
    x: number;
    /**
     * @generated from protobuf field: double y = 2
     */
    y: number;
}
/**
 * @generated from protobuf message algorithm.posture.RiskResult
 */
export interface RiskResult {
    /**
     * @generated from protobuf field: int32 id = 1
     */
    id: number;
    /**
     * 位置
     *
     * @generated from protobuf field: string position = 2
     */
    position: string;
    /**
     * 编号
     *
     * @generated from protobuf field: int32 code = 3
     */
    code: number;
    /**
     * 关键词
     *
     * @generated from protobuf field: string key = 4
     */
    key: string;
    /**
     * 名称
     *
     * @generated from protobuf field: string name = 5
     */
    name: string;
    /**
     * 角度
     *
     * @generated from protobuf field: double raw = 6
     */
    raw: number;
    /**
     * 位置是左还是右
     *
     * @generated from protobuf field: string direction = 7
     */
    direction: string;
    /**
     * 得分值
     *
     * @generated from protobuf field: double value = 8
     */
    value: number;
    /**
     * 严重程度
     *
     * @generated from protobuf field: string level = 9
     */
    level: string;
    /**
     * 描述
     *
     * @generated from protobuf field: string description = 10
     */
    description: string;
    /**
     * 详情
     *
     * @generated from protobuf field: string detail = 11
     */
    detail: string;
    /**
     * 是否有效
     *
     * @generated from protobuf field: bool valid = 12
     */
    valid: boolean;
    /**
     * 均值
     *
     * @generated from protobuf field: double meanValue = 13
     */
    meanValue: number;
}
/**
 * @generated from protobuf message algorithm.posture.TagResult
 */
export interface TagResult {
    /**
     * 编号
     *
     * @generated from protobuf field: int32 code = 2
     */
    code: number;
    /**
     * 结果描述
     *
     * @generated from protobuf field: string result = 3
     */
    result: string;
}
/**
 * @generated from protobuf message algorithm.posture.ResultResult
 */
export interface ResultResult {
    /**
     * 编号
     *
     * @generated from protobuf field: int32 code = 2
     */
    code: number;
    /**
     * 名称
     *
     * @generated from protobuf field: string name = 3
     */
    name: string;
    /**
     * 描述
     *
     * @generated from protobuf field: string description = 4
     */
    description: string;
}
/**
 * @generated from protobuf message algorithm.posture.ListSymptomsResponse
 */
export interface ListSymptomsResponse {
    /**
     * @generated from protobuf field: repeated algorithm.posture.ListSymptomsResponse.Symptom symptoms = 1
     */
    symptoms: ListSymptomsResponse_Symptom[];
}
/**
 * @generated from protobuf message algorithm.posture.ListSymptomsResponse.Symptom
 */
export interface ListSymptomsResponse_Symptom {
    /**
     * @generated from protobuf field: string name = 1
     */
    name: string;
    /**
     * @generated from protobuf field: string extra = 2
     */
    extra: string;
    /**
     * @generated from protobuf field: string display_name = 3
     */
    displayName: string;
    /**
     * @generated from protobuf field: string level = 4
     */
    level: string;
    /**
     * @generated from protobuf field: string level_display_name = 5
     */
    levelDisplayName: string;
}
/**
 * @generated from protobuf message algorithm.posture.GetPresignedPutObjectUrlRequest
 */
export interface GetPresignedPutObjectUrlRequest {
    /**
     * @generated from protobuf field: string object_type = 1
     */
    objectType: string; // valid value: image
    /**
     * @generated from protobuf field: string key = 2
     */
    key: string;
}
/**
 * @generated from protobuf message algorithm.posture.GetPresignedPutObjectUrlResponse
 */
export interface GetPresignedPutObjectUrlResponse {
    /**
     * @generated from protobuf field: string key = 1
     */
    key: string;
    /**
     * @generated from protobuf field: string url = 2
     */
    url: string;
}
/**
 * @generated from protobuf message algorithm.posture.ListReportTypesRequest
 */
export interface ListReportTypesRequest {
}
/**
 * @generated from protobuf message algorithm.posture.ListReportTypesResponse
 */
export interface ListReportTypesResponse {
    /**
     * @generated from protobuf field: repeated algorithm.posture.ReportType report_types = 1
     */
    reportTypes: ReportType[];
}
/**
 * @generated from protobuf message algorithm.posture.ReportType
 */
export interface ReportType {
    /**
     * @generated from protobuf field: string name = 1
     */
    name: string;
    /**
     * @generated from protobuf field: string display_name = 2
     */
    displayName: string;
}
/**
 * @generated from protobuf message algorithm.posture.AssignReportTypeByOrganizationIdRequest
 */
export interface AssignReportTypeByOrganizationIdRequest {
    /**
     * @generated from protobuf field: int64 organization_id = 1
     */
    organizationId: string;
    /**
     * @generated from protobuf field: algorithm.posture.ReportType report_type = 2
     */
    reportType?: ReportType;
}
/**
 * @generated from protobuf message algorithm.posture.AssignReportTypeByOrganizationIdResponse
 */
export interface AssignReportTypeByOrganizationIdResponse {
    /**
     * @generated from protobuf field: int64 organization_id = 1
     */
    organizationId: string;
    /**
     * @generated from protobuf field: algorithm.posture.ReportType report_type = 2
     */
    reportType?: ReportType;
}
/**
 * @generated from protobuf message algorithm.posture.GetReportTypeByOrganizationIdRequest
 */
export interface GetReportTypeByOrganizationIdRequest {
    /**
     * @generated from protobuf field: int64 organization_id = 1
     */
    organizationId: string;
}
/**
 * @generated from protobuf message algorithm.posture.GetReportTypeByOrganizationIdResponse
 */
export interface GetReportTypeByOrganizationIdResponse {
    /**
     * @generated from protobuf field: algorithm.posture.ReportType report_type = 1
     */
    reportType?: ReportType;
}
/**
 * @generated from protobuf message algorithm.posture.ListReportsWithoutOrganizationIdRequest
 */
export interface ListReportsWithoutOrganizationIdRequest {
    /**
     * @generated from protobuf field: int32 page_num = 1
     */
    pageNum: number;
    /**
     * @generated from protobuf field: int32 page_size = 2
     */
    pageSize: number;
    /**
     * @generated from protobuf field: google.protobuf.Int64Value account_id = 3
     */
    accountId?: Int64Value;
}
/**
 * @generated from protobuf message algorithm.posture.ListReportsWithoutOrganizationIdResponse
 */
export interface ListReportsWithoutOrganizationIdResponse {
    /**
     * @generated from protobuf field: repeated algorithm.posture.ListReportsWithoutOrganizationIdResponse.Header headers = 1
     */
    headers: ListReportsWithoutOrganizationIdResponse_Header[];
    /**
     * @generated from protobuf field: int64 total_elements = 2
     */
    totalElements: string;
    /**
     * @generated from protobuf field: int32 total_pages = 3
     */
    totalPages: number;
    /**
     * @generated from protobuf field: bool is_first = 4
     */
    isFirst: boolean;
    /**
     * @generated from protobuf field: bool is_last = 5
     */
    isLast: boolean;
    /**
     * @generated from protobuf field: int32 page_elements = 6
     */
    pageElements: number;
    /**
     * @generated from protobuf field: int32 page_num = 7
     */
    pageNum: number;
    /**
     * @generated from protobuf field: int32 page_size = 8
     */
    pageSize: number;
}
/**
 * @generated from protobuf message algorithm.posture.ListReportsWithoutOrganizationIdResponse.Header
 */
export interface ListReportsWithoutOrganizationIdResponse_Header {
    /**
     * @generated from protobuf field: google.protobuf.Int64Value account_id = 1
     */
    accountId?: Int64Value;
    /**
     * @generated from protobuf field: google.protobuf.StringValue uuid = 2
     */
    uuid?: StringValue;
}
/**
 * @generated from protobuf message algorithm.posture.RestoreReportOrganizationIdRequest
 */
export interface RestoreReportOrganizationIdRequest {
    /**
     * @generated from protobuf field: string uuid = 1
     */
    uuid: string;
    /**
     * @generated from protobuf field: int64 organization_id = 2
     */
    organizationId: string;
}
/**
 * @generated from protobuf message algorithm.posture.ReprocessPostureDataRequest
 */
export interface ReprocessPostureDataRequest {
    /**
     * @generated from protobuf field: string old_uuid = 1
     */
    oldUuid: string;
}
/**
 * @generated from protobuf message algorithm.posture.ReprocessPostureDataResponse
 */
export interface ReprocessPostureDataResponse {
    /**
     * @generated from protobuf field: string new_uuid = 1
     */
    newUuid: string;
}
/**
 * @generated from protobuf enum algorithm.posture.Side
 */
export enum Side {
    /**
     * @generated from protobuf enum value: side_zero = 0;
     */
    side_zero = 0,
    /**
     * @generated from protobuf enum value: left = 1;
     */
    left = 1,
    /**
     * @generated from protobuf enum value: right = 2;
     */
    right = 2
}
/**
 * @generated from protobuf enum algorithm.posture.Level
 */
export enum Level {
    /**
     * @generated from protobuf enum value: level_zero = 0;
     */
    level_zero = 0,
    /**
     * 正常
     *
     * @generated from protobuf enum value: normal = 1;
     */
    normal = 1,
    /**
     * 轻微
     *
     * @generated from protobuf enum value: mild = 2;
     */
    mild = 2,
    /**
     * 严重
     *
     * @generated from protobuf enum value: severe = 3;
     */
    severe = 3
}
// @generated message type with reflection information, may provide speed optimized methods
class GetLicenseInfoByAccountIdAndClientRequest$Type extends MessageType<GetLicenseInfoByAccountIdAndClientRequest> {
    constructor() {
        super("algorithm.posture.GetLicenseInfoByAccountIdAndClientRequest", [
            { no: 1, name: "accountId", kind: "scalar", T: 3 /*ScalarType.INT64*/ },
            { no: 2, name: "client", kind: "message", T: () => StringValue }
        ]);
    }
    create(value?: PartialMessage<GetLicenseInfoByAccountIdAndClientRequest>): GetLicenseInfoByAccountIdAndClientRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.accountId = "0";
        if (value !== undefined)
            reflectionMergePartial<GetLicenseInfoByAccountIdAndClientRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetLicenseInfoByAccountIdAndClientRequest): GetLicenseInfoByAccountIdAndClientRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 accountId */ 1:
                    message.accountId = reader.int64().toString();
                    break;
                case /* google.protobuf.StringValue client */ 2:
                    message.client = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.client);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetLicenseInfoByAccountIdAndClientRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 accountId = 1; */
        if (message.accountId !== "0")
            writer.tag(1, WireType.Varint).int64(message.accountId);
        /* google.protobuf.StringValue client = 2; */
        if (message.client)
            StringValue.internalBinaryWrite(message.client, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message algorithm.posture.GetLicenseInfoByAccountIdAndClientRequest
 */
export const GetLicenseInfoByAccountIdAndClientRequest = new GetLicenseInfoByAccountIdAndClientRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetLicenseInfoByAccountIdAndClientResponse$Type extends MessageType<GetLicenseInfoByAccountIdAndClientResponse> {
    constructor() {
        super("algorithm.posture.GetLicenseInfoByAccountIdAndClientResponse", [
            { no: 1, name: "licenseInfoResult", kind: "message", T: () => LicenseInfoResult }
        ]);
    }
    create(value?: PartialMessage<GetLicenseInfoByAccountIdAndClientResponse>): GetLicenseInfoByAccountIdAndClientResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetLicenseInfoByAccountIdAndClientResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetLicenseInfoByAccountIdAndClientResponse): GetLicenseInfoByAccountIdAndClientResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* algorithm.posture.LicenseInfoResult licenseInfoResult */ 1:
                    message.licenseInfoResult = LicenseInfoResult.internalBinaryRead(reader, reader.uint32(), options, message.licenseInfoResult);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetLicenseInfoByAccountIdAndClientResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* algorithm.posture.LicenseInfoResult licenseInfoResult = 1; */
        if (message.licenseInfoResult)
            LicenseInfoResult.internalBinaryWrite(message.licenseInfoResult, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message algorithm.posture.GetLicenseInfoByAccountIdAndClientResponse
 */
export const GetLicenseInfoByAccountIdAndClientResponse = new GetLicenseInfoByAccountIdAndClientResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetLicenseInfoByAccessTokenAndClientRequest$Type extends MessageType<GetLicenseInfoByAccessTokenAndClientRequest> {
    constructor() {
        super("algorithm.posture.GetLicenseInfoByAccessTokenAndClientRequest", []);
    }
    create(value?: PartialMessage<GetLicenseInfoByAccessTokenAndClientRequest>): GetLicenseInfoByAccessTokenAndClientRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetLicenseInfoByAccessTokenAndClientRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetLicenseInfoByAccessTokenAndClientRequest): GetLicenseInfoByAccessTokenAndClientRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetLicenseInfoByAccessTokenAndClientRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message algorithm.posture.GetLicenseInfoByAccessTokenAndClientRequest
 */
export const GetLicenseInfoByAccessTokenAndClientRequest = new GetLicenseInfoByAccessTokenAndClientRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetLicenseInfoByAccessTokenAndClientResponse$Type extends MessageType<GetLicenseInfoByAccessTokenAndClientResponse> {
    constructor() {
        super("algorithm.posture.GetLicenseInfoByAccessTokenAndClientResponse", [
            { no: 1, name: "licenseInfoResult", kind: "message", T: () => LicenseInfoResult }
        ]);
    }
    create(value?: PartialMessage<GetLicenseInfoByAccessTokenAndClientResponse>): GetLicenseInfoByAccessTokenAndClientResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetLicenseInfoByAccessTokenAndClientResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetLicenseInfoByAccessTokenAndClientResponse): GetLicenseInfoByAccessTokenAndClientResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* algorithm.posture.LicenseInfoResult licenseInfoResult */ 1:
                    message.licenseInfoResult = LicenseInfoResult.internalBinaryRead(reader, reader.uint32(), options, message.licenseInfoResult);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetLicenseInfoByAccessTokenAndClientResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* algorithm.posture.LicenseInfoResult licenseInfoResult = 1; */
        if (message.licenseInfoResult)
            LicenseInfoResult.internalBinaryWrite(message.licenseInfoResult, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message algorithm.posture.GetLicenseInfoByAccessTokenAndClientResponse
 */
export const GetLicenseInfoByAccessTokenAndClientResponse = new GetLicenseInfoByAccessTokenAndClientResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetLicenseInfoByOrganizationIdAndClientRequest$Type extends MessageType<GetLicenseInfoByOrganizationIdAndClientRequest> {
    constructor() {
        super("algorithm.posture.GetLicenseInfoByOrganizationIdAndClientRequest", [
            { no: 1, name: "organization_id", kind: "scalar", T: 3 /*ScalarType.INT64*/ },
            { no: 2, name: "client", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<GetLicenseInfoByOrganizationIdAndClientRequest>): GetLicenseInfoByOrganizationIdAndClientRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.organizationId = "0";
        message.client = "";
        if (value !== undefined)
            reflectionMergePartial<GetLicenseInfoByOrganizationIdAndClientRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetLicenseInfoByOrganizationIdAndClientRequest): GetLicenseInfoByOrganizationIdAndClientRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 organization_id */ 1:
                    message.organizationId = reader.int64().toString();
                    break;
                case /* string client */ 2:
                    message.client = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetLicenseInfoByOrganizationIdAndClientRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 organization_id = 1; */
        if (message.organizationId !== "0")
            writer.tag(1, WireType.Varint).int64(message.organizationId);
        /* string client = 2; */
        if (message.client !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.client);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message algorithm.posture.GetLicenseInfoByOrganizationIdAndClientRequest
 */
export const GetLicenseInfoByOrganizationIdAndClientRequest = new GetLicenseInfoByOrganizationIdAndClientRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetLicenseInfoByOrganizationIdAndClientResponse$Type extends MessageType<GetLicenseInfoByOrganizationIdAndClientResponse> {
    constructor() {
        super("algorithm.posture.GetLicenseInfoByOrganizationIdAndClientResponse", [
            { no: 1, name: "license_info", kind: "message", T: () => LicenseInfoResult }
        ]);
    }
    create(value?: PartialMessage<GetLicenseInfoByOrganizationIdAndClientResponse>): GetLicenseInfoByOrganizationIdAndClientResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetLicenseInfoByOrganizationIdAndClientResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetLicenseInfoByOrganizationIdAndClientResponse): GetLicenseInfoByOrganizationIdAndClientResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* algorithm.posture.LicenseInfoResult license_info */ 1:
                    message.licenseInfo = LicenseInfoResult.internalBinaryRead(reader, reader.uint32(), options, message.licenseInfo);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetLicenseInfoByOrganizationIdAndClientResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* algorithm.posture.LicenseInfoResult license_info = 1; */
        if (message.licenseInfo)
            LicenseInfoResult.internalBinaryWrite(message.licenseInfo, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message algorithm.posture.GetLicenseInfoByOrganizationIdAndClientResponse
 */
export const GetLicenseInfoByOrganizationIdAndClientResponse = new GetLicenseInfoByOrganizationIdAndClientResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetPostureReportHeaderListRequest$Type extends MessageType<GetPostureReportHeaderListRequest> {
    constructor() {
        super("algorithm.posture.GetPostureReportHeaderListRequest", [
            { no: 1, name: "uuids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "isSave", kind: "message", T: () => BoolValue },
            { no: 3, name: "language", kind: "message", T: () => StringValue }
        ]);
    }
    create(value?: PartialMessage<GetPostureReportHeaderListRequest>): GetPostureReportHeaderListRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.uuids = [];
        if (value !== undefined)
            reflectionMergePartial<GetPostureReportHeaderListRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetPostureReportHeaderListRequest): GetPostureReportHeaderListRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated string uuids */ 1:
                    message.uuids.push(reader.string());
                    break;
                case /* google.protobuf.BoolValue isSave */ 2:
                    message.isSave = BoolValue.internalBinaryRead(reader, reader.uint32(), options, message.isSave);
                    break;
                case /* google.protobuf.StringValue language */ 3:
                    message.language = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.language);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetPostureReportHeaderListRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated string uuids = 1; */
        for (let i = 0; i < message.uuids.length; i++)
            writer.tag(1, WireType.LengthDelimited).string(message.uuids[i]);
        /* google.protobuf.BoolValue isSave = 2; */
        if (message.isSave)
            BoolValue.internalBinaryWrite(message.isSave, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.StringValue language = 3; */
        if (message.language)
            StringValue.internalBinaryWrite(message.language, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message algorithm.posture.GetPostureReportHeaderListRequest
 */
export const GetPostureReportHeaderListRequest = new GetPostureReportHeaderListRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetPostureReportHeaderListResponse$Type extends MessageType<GetPostureReportHeaderListResponse> {
    constructor() {
        super("algorithm.posture.GetPostureReportHeaderListResponse", [
            { no: 1, name: "postureReportHeaders", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => PostureReportHeader }
        ]);
    }
    create(value?: PartialMessage<GetPostureReportHeaderListResponse>): GetPostureReportHeaderListResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.postureReportHeaders = [];
        if (value !== undefined)
            reflectionMergePartial<GetPostureReportHeaderListResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetPostureReportHeaderListResponse): GetPostureReportHeaderListResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated algorithm.posture.PostureReportHeader postureReportHeaders */ 1:
                    message.postureReportHeaders.push(PostureReportHeader.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetPostureReportHeaderListResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated algorithm.posture.PostureReportHeader postureReportHeaders = 1; */
        for (let i = 0; i < message.postureReportHeaders.length; i++)
            PostureReportHeader.internalBinaryWrite(message.postureReportHeaders[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message algorithm.posture.GetPostureReportHeaderListResponse
 */
export const GetPostureReportHeaderListResponse = new GetPostureReportHeaderListResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PostureReportHeader$Type extends MessageType<PostureReportHeader> {
    constructor() {
        super("algorithm.posture.PostureReportHeader", [
            { no: 1, name: "uuid", kind: "message", T: () => StringValue },
            { no: 2, name: "front", kind: "message", T: () => StringValue },
            { no: 3, name: "side", kind: "message", T: () => StringValue },
            { no: 4, name: "back", kind: "message", T: () => StringValue },
            { no: 5, name: "organizationId", kind: "message", T: () => Int64Value },
            { no: 6, name: "status", kind: "message", T: () => StringValue },
            { no: 7, name: "resultPosture", kind: "message", T: () => StringValue },
            { no: 8, name: "success", kind: "message", T: () => BoolValue },
            { no: 9, name: "postureTimestamp", kind: "message", T: () => Int64Value },
            { no: 10, name: "accountId", kind: "message", T: () => Int64Value },
            { no: 11, name: "urlForShare", kind: "message", T: () => StringValue },
            { no: 12, name: "urlForLocal", kind: "message", T: () => StringValue }
        ]);
    }
    create(value?: PartialMessage<PostureReportHeader>): PostureReportHeader {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<PostureReportHeader>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: PostureReportHeader): PostureReportHeader {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* google.protobuf.StringValue uuid */ 1:
                    message.uuid = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.uuid);
                    break;
                case /* google.protobuf.StringValue front */ 2:
                    message.front = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.front);
                    break;
                case /* google.protobuf.StringValue side */ 3:
                    message.side = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.side);
                    break;
                case /* google.protobuf.StringValue back */ 4:
                    message.back = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.back);
                    break;
                case /* google.protobuf.Int64Value organizationId */ 5:
                    message.organizationId = Int64Value.internalBinaryRead(reader, reader.uint32(), options, message.organizationId);
                    break;
                case /* google.protobuf.StringValue status */ 6:
                    message.status = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.status);
                    break;
                case /* google.protobuf.StringValue resultPosture */ 7:
                    message.resultPosture = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.resultPosture);
                    break;
                case /* google.protobuf.BoolValue success */ 8:
                    message.success = BoolValue.internalBinaryRead(reader, reader.uint32(), options, message.success);
                    break;
                case /* google.protobuf.Int64Value postureTimestamp */ 9:
                    message.postureTimestamp = Int64Value.internalBinaryRead(reader, reader.uint32(), options, message.postureTimestamp);
                    break;
                case /* google.protobuf.Int64Value accountId */ 10:
                    message.accountId = Int64Value.internalBinaryRead(reader, reader.uint32(), options, message.accountId);
                    break;
                case /* google.protobuf.StringValue urlForShare */ 11:
                    message.urlForShare = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.urlForShare);
                    break;
                case /* google.protobuf.StringValue urlForLocal */ 12:
                    message.urlForLocal = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.urlForLocal);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: PostureReportHeader, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* google.protobuf.StringValue uuid = 1; */
        if (message.uuid)
            StringValue.internalBinaryWrite(message.uuid, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.StringValue front = 2; */
        if (message.front)
            StringValue.internalBinaryWrite(message.front, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.StringValue side = 3; */
        if (message.side)
            StringValue.internalBinaryWrite(message.side, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.StringValue back = 4; */
        if (message.back)
            StringValue.internalBinaryWrite(message.back, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Int64Value organizationId = 5; */
        if (message.organizationId)
            Int64Value.internalBinaryWrite(message.organizationId, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.StringValue status = 6; */
        if (message.status)
            StringValue.internalBinaryWrite(message.status, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.StringValue resultPosture = 7; */
        if (message.resultPosture)
            StringValue.internalBinaryWrite(message.resultPosture, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.BoolValue success = 8; */
        if (message.success)
            BoolValue.internalBinaryWrite(message.success, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Int64Value postureTimestamp = 9; */
        if (message.postureTimestamp)
            Int64Value.internalBinaryWrite(message.postureTimestamp, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Int64Value accountId = 10; */
        if (message.accountId)
            Int64Value.internalBinaryWrite(message.accountId, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.StringValue urlForShare = 11; */
        if (message.urlForShare)
            StringValue.internalBinaryWrite(message.urlForShare, writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.StringValue urlForLocal = 12; */
        if (message.urlForLocal)
            StringValue.internalBinaryWrite(message.urlForLocal, writer.tag(12, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message algorithm.posture.PostureReportHeader
 */
export const PostureReportHeader = new PostureReportHeader$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetLicenseInfoByAccountIdsRequest$Type extends MessageType<GetLicenseInfoByAccountIdsRequest> {
    constructor() {
        super("algorithm.posture.GetLicenseInfoByAccountIdsRequest", [
            { no: 1, name: "accountIds", kind: "scalar", repeat: 1 /*RepeatType.PACKED*/, T: 3 /*ScalarType.INT64*/ }
        ]);
    }
    create(value?: PartialMessage<GetLicenseInfoByAccountIdsRequest>): GetLicenseInfoByAccountIdsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.accountIds = [];
        if (value !== undefined)
            reflectionMergePartial<GetLicenseInfoByAccountIdsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetLicenseInfoByAccountIdsRequest): GetLicenseInfoByAccountIdsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated int64 accountIds */ 1:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.accountIds.push(reader.int64().toString());
                    else
                        message.accountIds.push(reader.int64().toString());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetLicenseInfoByAccountIdsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated int64 accountIds = 1; */
        if (message.accountIds.length) {
            writer.tag(1, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.accountIds.length; i++)
                writer.int64(message.accountIds[i]);
            writer.join();
        }
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message algorithm.posture.GetLicenseInfoByAccountIdsRequest
 */
export const GetLicenseInfoByAccountIdsRequest = new GetLicenseInfoByAccountIdsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetLicenseInfoByAccountIdsResponse$Type extends MessageType<GetLicenseInfoByAccountIdsResponse> {
    constructor() {
        super("algorithm.posture.GetLicenseInfoByAccountIdsResponse", [
            { no: 1, name: "licenseInfoResults", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => LicenseInfoResult }
        ]);
    }
    create(value?: PartialMessage<GetLicenseInfoByAccountIdsResponse>): GetLicenseInfoByAccountIdsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.licenseInfoResults = [];
        if (value !== undefined)
            reflectionMergePartial<GetLicenseInfoByAccountIdsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetLicenseInfoByAccountIdsResponse): GetLicenseInfoByAccountIdsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated algorithm.posture.LicenseInfoResult licenseInfoResults */ 1:
                    message.licenseInfoResults.push(LicenseInfoResult.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetLicenseInfoByAccountIdsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated algorithm.posture.LicenseInfoResult licenseInfoResults = 1; */
        for (let i = 0; i < message.licenseInfoResults.length; i++)
            LicenseInfoResult.internalBinaryWrite(message.licenseInfoResults[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message algorithm.posture.GetLicenseInfoByAccountIdsResponse
 */
export const GetLicenseInfoByAccountIdsResponse = new GetLicenseInfoByAccountIdsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetLicenseInfoRequest$Type extends MessageType<GetLicenseInfoRequest> {
    constructor() {
        super("algorithm.posture.GetLicenseInfoRequest", []);
    }
    create(value?: PartialMessage<GetLicenseInfoRequest>): GetLicenseInfoRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetLicenseInfoRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetLicenseInfoRequest): GetLicenseInfoRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetLicenseInfoRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message algorithm.posture.GetLicenseInfoRequest
 */
export const GetLicenseInfoRequest = new GetLicenseInfoRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetLicenseInfoResponse$Type extends MessageType<GetLicenseInfoResponse> {
    constructor() {
        super("algorithm.posture.GetLicenseInfoResponse", [
            { no: 1, name: "licenseInfoResults", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => LicenseInfoResult }
        ]);
    }
    create(value?: PartialMessage<GetLicenseInfoResponse>): GetLicenseInfoResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.licenseInfoResults = [];
        if (value !== undefined)
            reflectionMergePartial<GetLicenseInfoResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetLicenseInfoResponse): GetLicenseInfoResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated algorithm.posture.LicenseInfoResult licenseInfoResults */ 1:
                    message.licenseInfoResults.push(LicenseInfoResult.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetLicenseInfoResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated algorithm.posture.LicenseInfoResult licenseInfoResults = 1; */
        for (let i = 0; i < message.licenseInfoResults.length; i++)
            LicenseInfoResult.internalBinaryWrite(message.licenseInfoResults[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message algorithm.posture.GetLicenseInfoResponse
 */
export const GetLicenseInfoResponse = new GetLicenseInfoResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class LicenseInfoResult$Type extends MessageType<LicenseInfoResult> {
    constructor() {
        super("algorithm.posture.LicenseInfoResult", [
            { no: 1, name: "organizationId", kind: "message", T: () => Int64Value },
            { no: 2, name: "endTimestamp", kind: "message", T: () => Int64Value },
            { no: 3, name: "count", kind: "message", T: () => Int64Value },
            { no: 4, name: "accountId", kind: "message", T: () => Int64Value },
            { no: 5, name: "totalCount", kind: "message", T: () => Int64Value }
        ]);
    }
    create(value?: PartialMessage<LicenseInfoResult>): LicenseInfoResult {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<LicenseInfoResult>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: LicenseInfoResult): LicenseInfoResult {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* google.protobuf.Int64Value organizationId */ 1:
                    message.organizationId = Int64Value.internalBinaryRead(reader, reader.uint32(), options, message.organizationId);
                    break;
                case /* google.protobuf.Int64Value endTimestamp */ 2:
                    message.endTimestamp = Int64Value.internalBinaryRead(reader, reader.uint32(), options, message.endTimestamp);
                    break;
                case /* google.protobuf.Int64Value count */ 3:
                    message.count = Int64Value.internalBinaryRead(reader, reader.uint32(), options, message.count);
                    break;
                case /* google.protobuf.Int64Value accountId */ 4:
                    message.accountId = Int64Value.internalBinaryRead(reader, reader.uint32(), options, message.accountId);
                    break;
                case /* google.protobuf.Int64Value totalCount */ 5:
                    message.totalCount = Int64Value.internalBinaryRead(reader, reader.uint32(), options, message.totalCount);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: LicenseInfoResult, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* google.protobuf.Int64Value organizationId = 1; */
        if (message.organizationId)
            Int64Value.internalBinaryWrite(message.organizationId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Int64Value endTimestamp = 2; */
        if (message.endTimestamp)
            Int64Value.internalBinaryWrite(message.endTimestamp, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Int64Value count = 3; */
        if (message.count)
            Int64Value.internalBinaryWrite(message.count, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Int64Value accountId = 4; */
        if (message.accountId)
            Int64Value.internalBinaryWrite(message.accountId, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Int64Value totalCount = 5; */
        if (message.totalCount)
            Int64Value.internalBinaryWrite(message.totalCount, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message algorithm.posture.LicenseInfoResult
 */
export const LicenseInfoResult = new LicenseInfoResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdatePostureReportCoordinateResponse$Type extends MessageType<UpdatePostureReportCoordinateResponse> {
    constructor() {
        super("algorithm.posture.UpdatePostureReportCoordinateResponse", [
            { no: 1, name: "isUpdated", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<UpdatePostureReportCoordinateResponse>): UpdatePostureReportCoordinateResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.isUpdated = false;
        if (value !== undefined)
            reflectionMergePartial<UpdatePostureReportCoordinateResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdatePostureReportCoordinateResponse): UpdatePostureReportCoordinateResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool isUpdated */ 1:
                    message.isUpdated = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdatePostureReportCoordinateResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool isUpdated = 1; */
        if (message.isUpdated !== false)
            writer.tag(1, WireType.Varint).bool(message.isUpdated);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message algorithm.posture.UpdatePostureReportCoordinateResponse
 */
export const UpdatePostureReportCoordinateResponse = new UpdatePostureReportCoordinateResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdatePostureReportCoordinateRequest$Type extends MessageType<UpdatePostureReportCoordinateRequest> {
    constructor() {
        super("algorithm.posture.UpdatePostureReportCoordinateRequest", [
            { no: 1, name: "front", kind: "message", T: () => PointsResult },
            { no: 2, name: "side", kind: "message", T: () => PointsResult },
            { no: 3, name: "uuid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "back", kind: "message", T: () => PointsResult },
            { no: 5, name: "other_side", kind: "message", T: () => PointsResult }
        ]);
    }
    create(value?: PartialMessage<UpdatePostureReportCoordinateRequest>): UpdatePostureReportCoordinateRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.uuid = "";
        if (value !== undefined)
            reflectionMergePartial<UpdatePostureReportCoordinateRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdatePostureReportCoordinateRequest): UpdatePostureReportCoordinateRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* algorithm.posture.PointsResult front */ 1:
                    message.front = PointsResult.internalBinaryRead(reader, reader.uint32(), options, message.front);
                    break;
                case /* algorithm.posture.PointsResult side */ 2:
                    message.side = PointsResult.internalBinaryRead(reader, reader.uint32(), options, message.side);
                    break;
                case /* string uuid */ 3:
                    message.uuid = reader.string();
                    break;
                case /* algorithm.posture.PointsResult back */ 4:
                    message.back = PointsResult.internalBinaryRead(reader, reader.uint32(), options, message.back);
                    break;
                case /* algorithm.posture.PointsResult other_side */ 5:
                    message.otherSide = PointsResult.internalBinaryRead(reader, reader.uint32(), options, message.otherSide);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdatePostureReportCoordinateRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* algorithm.posture.PointsResult front = 1; */
        if (message.front)
            PointsResult.internalBinaryWrite(message.front, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* algorithm.posture.PointsResult side = 2; */
        if (message.side)
            PointsResult.internalBinaryWrite(message.side, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* string uuid = 3; */
        if (message.uuid !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.uuid);
        /* algorithm.posture.PointsResult back = 4; */
        if (message.back)
            PointsResult.internalBinaryWrite(message.back, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* algorithm.posture.PointsResult other_side = 5; */
        if (message.otherSide)
            PointsResult.internalBinaryWrite(message.otherSide, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message algorithm.posture.UpdatePostureReportCoordinateRequest
 */
export const UpdatePostureReportCoordinateRequest = new UpdatePostureReportCoordinateRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetMuscleStateRequest$Type extends MessageType<GetMuscleStateRequest> {
    constructor() {
        super("algorithm.posture.GetMuscleStateRequest", [
            { no: 1, name: "muscleStateQuery", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => GetMuscleStateRequest_MuscleStateQuery },
            { no: 2, name: "lang", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<GetMuscleStateRequest>): GetMuscleStateRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.muscleStateQuery = [];
        message.lang = "";
        if (value !== undefined)
            reflectionMergePartial<GetMuscleStateRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetMuscleStateRequest): GetMuscleStateRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated algorithm.posture.GetMuscleStateRequest.MuscleStateQuery muscleStateQuery */ 1:
                    message.muscleStateQuery.push(GetMuscleStateRequest_MuscleStateQuery.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string lang */ 2:
                    message.lang = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetMuscleStateRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated algorithm.posture.GetMuscleStateRequest.MuscleStateQuery muscleStateQuery = 1; */
        for (let i = 0; i < message.muscleStateQuery.length; i++)
            GetMuscleStateRequest_MuscleStateQuery.internalBinaryWrite(message.muscleStateQuery[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string lang = 2; */
        if (message.lang !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.lang);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message algorithm.posture.GetMuscleStateRequest
 */
export const GetMuscleStateRequest = new GetMuscleStateRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetMuscleStateRequest_MuscleStateQuery$Type extends MessageType<GetMuscleStateRequest_MuscleStateQuery> {
    constructor() {
        super("algorithm.posture.GetMuscleStateRequest.MuscleStateQuery", [
            { no: 1, name: "key", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "direction", kind: "enum", T: () => ["algorithm.posture.Side", Side] },
            { no: 3, name: "level", kind: "enum", T: () => ["algorithm.posture.Level", Level] }
        ]);
    }
    create(value?: PartialMessage<GetMuscleStateRequest_MuscleStateQuery>): GetMuscleStateRequest_MuscleStateQuery {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.key = "";
        message.direction = 0;
        message.level = 0;
        if (value !== undefined)
            reflectionMergePartial<GetMuscleStateRequest_MuscleStateQuery>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetMuscleStateRequest_MuscleStateQuery): GetMuscleStateRequest_MuscleStateQuery {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string key */ 1:
                    message.key = reader.string();
                    break;
                case /* algorithm.posture.Side direction */ 2:
                    message.direction = reader.int32();
                    break;
                case /* algorithm.posture.Level level */ 3:
                    message.level = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetMuscleStateRequest_MuscleStateQuery, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string key = 1; */
        if (message.key !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.key);
        /* algorithm.posture.Side direction = 2; */
        if (message.direction !== 0)
            writer.tag(2, WireType.Varint).int32(message.direction);
        /* algorithm.posture.Level level = 3; */
        if (message.level !== 0)
            writer.tag(3, WireType.Varint).int32(message.level);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message algorithm.posture.GetMuscleStateRequest.MuscleStateQuery
 */
export const GetMuscleStateRequest_MuscleStateQuery = new GetMuscleStateRequest_MuscleStateQuery$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetMuscleStateResponse$Type extends MessageType<GetMuscleStateResponse> {
    constructor() {
        super("algorithm.posture.GetMuscleStateResponse", [
            { no: 1, name: "muscleStateResults", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => GetMuscleStateResponse_MuscleStateResult }
        ]);
    }
    create(value?: PartialMessage<GetMuscleStateResponse>): GetMuscleStateResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.muscleStateResults = [];
        if (value !== undefined)
            reflectionMergePartial<GetMuscleStateResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetMuscleStateResponse): GetMuscleStateResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated algorithm.posture.GetMuscleStateResponse.MuscleStateResult muscleStateResults */ 1:
                    message.muscleStateResults.push(GetMuscleStateResponse_MuscleStateResult.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetMuscleStateResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated algorithm.posture.GetMuscleStateResponse.MuscleStateResult muscleStateResults = 1; */
        for (let i = 0; i < message.muscleStateResults.length; i++)
            GetMuscleStateResponse_MuscleStateResult.internalBinaryWrite(message.muscleStateResults[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message algorithm.posture.GetMuscleStateResponse
 */
export const GetMuscleStateResponse = new GetMuscleStateResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetMuscleStateResponse_MuscleStateResult$Type extends MessageType<GetMuscleStateResponse_MuscleStateResult> {
    constructor() {
        super("algorithm.posture.GetMuscleStateResponse.MuscleStateResult", [
            { no: 1, name: "muscleStateId", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "detailId", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "key", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "direction", kind: "enum", T: () => ["algorithm.posture.Side", Side] },
            { no: 5, name: "level", kind: "enum", T: () => ["algorithm.posture.Level", Level] },
            { no: 6, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "image", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "diseaseMuscleResults", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => GetMuscleStateResponse_DiseaseMuscleResult },
            { no: 9, name: "diseaseParts", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => GetMuscleStateResponse_DiseaseParts }
        ]);
    }
    create(value?: PartialMessage<GetMuscleStateResponse_MuscleStateResult>): GetMuscleStateResponse_MuscleStateResult {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.muscleStateId = 0;
        message.detailId = 0;
        message.key = "";
        message.direction = 0;
        message.level = 0;
        message.name = "";
        message.image = "";
        message.diseaseMuscleResults = [];
        message.diseaseParts = [];
        if (value !== undefined)
            reflectionMergePartial<GetMuscleStateResponse_MuscleStateResult>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetMuscleStateResponse_MuscleStateResult): GetMuscleStateResponse_MuscleStateResult {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 muscleStateId */ 1:
                    message.muscleStateId = reader.int32();
                    break;
                case /* int32 detailId */ 2:
                    message.detailId = reader.int32();
                    break;
                case /* string key */ 3:
                    message.key = reader.string();
                    break;
                case /* algorithm.posture.Side direction */ 4:
                    message.direction = reader.int32();
                    break;
                case /* algorithm.posture.Level level */ 5:
                    message.level = reader.int32();
                    break;
                case /* string name */ 6:
                    message.name = reader.string();
                    break;
                case /* string image */ 7:
                    message.image = reader.string();
                    break;
                case /* repeated algorithm.posture.GetMuscleStateResponse.DiseaseMuscleResult diseaseMuscleResults */ 8:
                    message.diseaseMuscleResults.push(GetMuscleStateResponse_DiseaseMuscleResult.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated algorithm.posture.GetMuscleStateResponse.DiseaseParts diseaseParts */ 9:
                    message.diseaseParts.push(GetMuscleStateResponse_DiseaseParts.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetMuscleStateResponse_MuscleStateResult, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 muscleStateId = 1; */
        if (message.muscleStateId !== 0)
            writer.tag(1, WireType.Varint).int32(message.muscleStateId);
        /* int32 detailId = 2; */
        if (message.detailId !== 0)
            writer.tag(2, WireType.Varint).int32(message.detailId);
        /* string key = 3; */
        if (message.key !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.key);
        /* algorithm.posture.Side direction = 4; */
        if (message.direction !== 0)
            writer.tag(4, WireType.Varint).int32(message.direction);
        /* algorithm.posture.Level level = 5; */
        if (message.level !== 0)
            writer.tag(5, WireType.Varint).int32(message.level);
        /* string name = 6; */
        if (message.name !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.name);
        /* string image = 7; */
        if (message.image !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.image);
        /* repeated algorithm.posture.GetMuscleStateResponse.DiseaseMuscleResult diseaseMuscleResults = 8; */
        for (let i = 0; i < message.diseaseMuscleResults.length; i++)
            GetMuscleStateResponse_DiseaseMuscleResult.internalBinaryWrite(message.diseaseMuscleResults[i], writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* repeated algorithm.posture.GetMuscleStateResponse.DiseaseParts diseaseParts = 9; */
        for (let i = 0; i < message.diseaseParts.length; i++)
            GetMuscleStateResponse_DiseaseParts.internalBinaryWrite(message.diseaseParts[i], writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message algorithm.posture.GetMuscleStateResponse.MuscleStateResult
 */
export const GetMuscleStateResponse_MuscleStateResult = new GetMuscleStateResponse_MuscleStateResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetMuscleStateResponse_DiseaseMuscleResult$Type extends MessageType<GetMuscleStateResponse_DiseaseMuscleResult> {
    constructor() {
        super("algorithm.posture.GetMuscleStateResponse.DiseaseMuscleResult", [
            { no: 1, name: "diseaseMuscleId", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "detailId", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "muscleResult", kind: "message", T: () => GetMuscleStateResponse_MuscleResult },
            { no: 4, name: "side", kind: "enum", T: () => ["algorithm.posture.Side", Side] },
            { no: 5, name: "status", kind: "enum", T: () => ["algorithm.posture.GetMuscleStateResponse.Status", GetMuscleStateResponse_Status] },
            { no: 6, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<GetMuscleStateResponse_DiseaseMuscleResult>): GetMuscleStateResponse_DiseaseMuscleResult {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.diseaseMuscleId = 0;
        message.detailId = 0;
        message.side = 0;
        message.status = 0;
        message.description = "";
        if (value !== undefined)
            reflectionMergePartial<GetMuscleStateResponse_DiseaseMuscleResult>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetMuscleStateResponse_DiseaseMuscleResult): GetMuscleStateResponse_DiseaseMuscleResult {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 diseaseMuscleId */ 1:
                    message.diseaseMuscleId = reader.int32();
                    break;
                case /* int32 detailId */ 2:
                    message.detailId = reader.int32();
                    break;
                case /* algorithm.posture.GetMuscleStateResponse.MuscleResult muscleResult */ 3:
                    message.muscleResult = GetMuscleStateResponse_MuscleResult.internalBinaryRead(reader, reader.uint32(), options, message.muscleResult);
                    break;
                case /* algorithm.posture.Side side */ 4:
                    message.side = reader.int32();
                    break;
                case /* algorithm.posture.GetMuscleStateResponse.Status status */ 5:
                    message.status = reader.int32();
                    break;
                case /* string description */ 6:
                    message.description = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetMuscleStateResponse_DiseaseMuscleResult, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 diseaseMuscleId = 1; */
        if (message.diseaseMuscleId !== 0)
            writer.tag(1, WireType.Varint).int32(message.diseaseMuscleId);
        /* int32 detailId = 2; */
        if (message.detailId !== 0)
            writer.tag(2, WireType.Varint).int32(message.detailId);
        /* algorithm.posture.GetMuscleStateResponse.MuscleResult muscleResult = 3; */
        if (message.muscleResult)
            GetMuscleStateResponse_MuscleResult.internalBinaryWrite(message.muscleResult, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* algorithm.posture.Side side = 4; */
        if (message.side !== 0)
            writer.tag(4, WireType.Varint).int32(message.side);
        /* algorithm.posture.GetMuscleStateResponse.Status status = 5; */
        if (message.status !== 0)
            writer.tag(5, WireType.Varint).int32(message.status);
        /* string description = 6; */
        if (message.description !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.description);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message algorithm.posture.GetMuscleStateResponse.DiseaseMuscleResult
 */
export const GetMuscleStateResponse_DiseaseMuscleResult = new GetMuscleStateResponse_DiseaseMuscleResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetMuscleStateResponse_DiseaseParts$Type extends MessageType<GetMuscleStateResponse_DiseaseParts> {
    constructor() {
        super("algorithm.posture.GetMuscleStateResponse.DiseaseParts", [
            { no: 1, name: "diseasePartsId", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "muscleStateId", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "side", kind: "enum", T: () => ["algorithm.posture.Side", Side] },
            { no: 5, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "image", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "parts", kind: "message", T: () => GetMuscleStateResponse_Parts }
        ]);
    }
    create(value?: PartialMessage<GetMuscleStateResponse_DiseaseParts>): GetMuscleStateResponse_DiseaseParts {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.diseasePartsId = 0;
        message.muscleStateId = 0;
        message.side = 0;
        message.description = "";
        message.image = "";
        if (value !== undefined)
            reflectionMergePartial<GetMuscleStateResponse_DiseaseParts>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetMuscleStateResponse_DiseaseParts): GetMuscleStateResponse_DiseaseParts {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 diseasePartsId */ 1:
                    message.diseasePartsId = reader.int32();
                    break;
                case /* int32 muscleStateId */ 2:
                    message.muscleStateId = reader.int32();
                    break;
                case /* algorithm.posture.Side side */ 3:
                    message.side = reader.int32();
                    break;
                case /* string description */ 5:
                    message.description = reader.string();
                    break;
                case /* string image */ 6:
                    message.image = reader.string();
                    break;
                case /* algorithm.posture.GetMuscleStateResponse.Parts parts */ 7:
                    message.parts = GetMuscleStateResponse_Parts.internalBinaryRead(reader, reader.uint32(), options, message.parts);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetMuscleStateResponse_DiseaseParts, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 diseasePartsId = 1; */
        if (message.diseasePartsId !== 0)
            writer.tag(1, WireType.Varint).int32(message.diseasePartsId);
        /* int32 muscleStateId = 2; */
        if (message.muscleStateId !== 0)
            writer.tag(2, WireType.Varint).int32(message.muscleStateId);
        /* algorithm.posture.Side side = 3; */
        if (message.side !== 0)
            writer.tag(3, WireType.Varint).int32(message.side);
        /* string description = 5; */
        if (message.description !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.description);
        /* string image = 6; */
        if (message.image !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.image);
        /* algorithm.posture.GetMuscleStateResponse.Parts parts = 7; */
        if (message.parts)
            GetMuscleStateResponse_Parts.internalBinaryWrite(message.parts, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message algorithm.posture.GetMuscleStateResponse.DiseaseParts
 */
export const GetMuscleStateResponse_DiseaseParts = new GetMuscleStateResponse_DiseaseParts$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetMuscleStateResponse_MuscleResult$Type extends MessageType<GetMuscleStateResponse_MuscleResult> {
    constructor() {
        super("algorithm.posture.GetMuscleStateResponse.MuscleResult", [
            { no: 1, name: "muscleId", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "muscleKey", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<GetMuscleStateResponse_MuscleResult>): GetMuscleStateResponse_MuscleResult {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.muscleId = 0;
        message.muscleKey = "";
        message.name = "";
        if (value !== undefined)
            reflectionMergePartial<GetMuscleStateResponse_MuscleResult>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetMuscleStateResponse_MuscleResult): GetMuscleStateResponse_MuscleResult {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 muscleId */ 1:
                    message.muscleId = reader.int32();
                    break;
                case /* string muscleKey */ 2:
                    message.muscleKey = reader.string();
                    break;
                case /* string name */ 3:
                    message.name = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetMuscleStateResponse_MuscleResult, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 muscleId = 1; */
        if (message.muscleId !== 0)
            writer.tag(1, WireType.Varint).int32(message.muscleId);
        /* string muscleKey = 2; */
        if (message.muscleKey !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.muscleKey);
        /* string name = 3; */
        if (message.name !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.name);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message algorithm.posture.GetMuscleStateResponse.MuscleResult
 */
export const GetMuscleStateResponse_MuscleResult = new GetMuscleStateResponse_MuscleResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetMuscleStateResponse_Parts$Type extends MessageType<GetMuscleStateResponse_Parts> {
    constructor() {
        super("algorithm.posture.GetMuscleStateResponse.Parts", [
            { no: 1, name: "partsId", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "partsKey", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<GetMuscleStateResponse_Parts>): GetMuscleStateResponse_Parts {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.partsId = 0;
        message.partsKey = "";
        message.name = "";
        if (value !== undefined)
            reflectionMergePartial<GetMuscleStateResponse_Parts>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetMuscleStateResponse_Parts): GetMuscleStateResponse_Parts {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 partsId */ 1:
                    message.partsId = reader.int32();
                    break;
                case /* string partsKey */ 2:
                    message.partsKey = reader.string();
                    break;
                case /* string name */ 3:
                    message.name = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetMuscleStateResponse_Parts, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 partsId = 1; */
        if (message.partsId !== 0)
            writer.tag(1, WireType.Varint).int32(message.partsId);
        /* string partsKey = 2; */
        if (message.partsKey !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.partsKey);
        /* string name = 3; */
        if (message.name !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.name);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message algorithm.posture.GetMuscleStateResponse.Parts
 */
export const GetMuscleStateResponse_Parts = new GetMuscleStateResponse_Parts$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetPostureReportListRequest$Type extends MessageType<GetPostureReportListRequest> {
    constructor() {
        super("algorithm.posture.GetPostureReportListRequest", [
            { no: 1, name: "uuid", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "language", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "organizationId", kind: "message", T: () => Int64Value },
            { no: 4, name: "isSave", kind: "message", T: () => BoolValue }
        ]);
    }
    create(value?: PartialMessage<GetPostureReportListRequest>): GetPostureReportListRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.uuid = [];
        message.language = "";
        if (value !== undefined)
            reflectionMergePartial<GetPostureReportListRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetPostureReportListRequest): GetPostureReportListRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated string uuid */ 1:
                    message.uuid.push(reader.string());
                    break;
                case /* string language */ 2:
                    message.language = reader.string();
                    break;
                case /* google.protobuf.Int64Value organizationId */ 3:
                    message.organizationId = Int64Value.internalBinaryRead(reader, reader.uint32(), options, message.organizationId);
                    break;
                case /* google.protobuf.BoolValue isSave */ 4:
                    message.isSave = BoolValue.internalBinaryRead(reader, reader.uint32(), options, message.isSave);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetPostureReportListRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated string uuid = 1; */
        for (let i = 0; i < message.uuid.length; i++)
            writer.tag(1, WireType.LengthDelimited).string(message.uuid[i]);
        /* string language = 2; */
        if (message.language !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.language);
        /* google.protobuf.Int64Value organizationId = 3; */
        if (message.organizationId)
            Int64Value.internalBinaryWrite(message.organizationId, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.BoolValue isSave = 4; */
        if (message.isSave)
            BoolValue.internalBinaryWrite(message.isSave, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message algorithm.posture.GetPostureReportListRequest
 */
export const GetPostureReportListRequest = new GetPostureReportListRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetPostureReportListResponse$Type extends MessageType<GetPostureReportListResponse> {
    constructor() {
        super("algorithm.posture.GetPostureReportListResponse", [
            { no: 1, name: "postureReportList", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => GetPostureReportResponse }
        ]);
    }
    create(value?: PartialMessage<GetPostureReportListResponse>): GetPostureReportListResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.postureReportList = [];
        if (value !== undefined)
            reflectionMergePartial<GetPostureReportListResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetPostureReportListResponse): GetPostureReportListResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated algorithm.posture.GetPostureReportResponse postureReportList */ 1:
                    message.postureReportList.push(GetPostureReportResponse.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetPostureReportListResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated algorithm.posture.GetPostureReportResponse postureReportList = 1; */
        for (let i = 0; i < message.postureReportList.length; i++)
            GetPostureReportResponse.internalBinaryWrite(message.postureReportList[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message algorithm.posture.GetPostureReportListResponse
 */
export const GetPostureReportListResponse = new GetPostureReportListResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetReportHeaderRequest$Type extends MessageType<GetReportHeaderRequest> {
    constructor() {
        super("algorithm.posture.GetReportHeaderRequest", [
            { no: 1, name: "uuid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "language", kind: "message", T: () => StringValue },
            { no: 3, name: "editable", kind: "message", T: () => BoolValue }
        ]);
    }
    create(value?: PartialMessage<GetReportHeaderRequest>): GetReportHeaderRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.uuid = "";
        if (value !== undefined)
            reflectionMergePartial<GetReportHeaderRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetReportHeaderRequest): GetReportHeaderRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string uuid */ 1:
                    message.uuid = reader.string();
                    break;
                case /* google.protobuf.StringValue language */ 2:
                    message.language = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.language);
                    break;
                case /* google.protobuf.BoolValue editable */ 3:
                    message.editable = BoolValue.internalBinaryRead(reader, reader.uint32(), options, message.editable);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetReportHeaderRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string uuid = 1; */
        if (message.uuid !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.uuid);
        /* google.protobuf.StringValue language = 2; */
        if (message.language)
            StringValue.internalBinaryWrite(message.language, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.BoolValue editable = 3; */
        if (message.editable)
            BoolValue.internalBinaryWrite(message.editable, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message algorithm.posture.GetReportHeaderRequest
 */
export const GetReportHeaderRequest = new GetReportHeaderRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ReportHeader$Type extends MessageType<ReportHeader> {
    constructor() {
        super("algorithm.posture.ReportHeader", [
            { no: 1, name: "uuid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "create_time", kind: "message", T: () => Timestamp },
            { no: 3, name: "process_status", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "report_url", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "examinee", kind: "message", T: () => ReportHeader_Examinee }
        ]);
    }
    create(value?: PartialMessage<ReportHeader>): ReportHeader {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.uuid = "";
        message.processStatus = "";
        message.reportUrl = "";
        if (value !== undefined)
            reflectionMergePartial<ReportHeader>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ReportHeader): ReportHeader {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string uuid */ 1:
                    message.uuid = reader.string();
                    break;
                case /* google.protobuf.Timestamp create_time */ 2:
                    message.createTime = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createTime);
                    break;
                case /* string process_status */ 3:
                    message.processStatus = reader.string();
                    break;
                case /* string report_url */ 6:
                    message.reportUrl = reader.string();
                    break;
                case /* algorithm.posture.ReportHeader.Examinee examinee */ 7:
                    message.examinee = ReportHeader_Examinee.internalBinaryRead(reader, reader.uint32(), options, message.examinee);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ReportHeader, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string uuid = 1; */
        if (message.uuid !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.uuid);
        /* google.protobuf.Timestamp create_time = 2; */
        if (message.createTime)
            Timestamp.internalBinaryWrite(message.createTime, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* string process_status = 3; */
        if (message.processStatus !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.processStatus);
        /* string report_url = 6; */
        if (message.reportUrl !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.reportUrl);
        /* algorithm.posture.ReportHeader.Examinee examinee = 7; */
        if (message.examinee)
            ReportHeader_Examinee.internalBinaryWrite(message.examinee, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message algorithm.posture.ReportHeader
 */
export const ReportHeader = new ReportHeader$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ReportHeader_Examinee$Type extends MessageType<ReportHeader_Examinee> {
    constructor() {
        super("algorithm.posture.ReportHeader.Examinee", [
            { no: 1, name: "name", kind: "message", T: () => StringValue },
            { no: 2, name: "gender", kind: "message", T: () => StringValue },
            { no: 3, name: "age", kind: "message", T: () => Int32Value },
            { no: 4, name: "height", kind: "message", T: () => Int32Value },
            { no: 5, name: "weight", kind: "message", T: () => Int32Value },
            { no: 6, name: "description", kind: "message", T: () => StringValue },
            { no: 10, name: "phone_number", kind: "message", T: () => StringValue },
            { no: 11, name: "id_number", kind: "message", T: () => StringValue }
        ]);
    }
    create(value?: PartialMessage<ReportHeader_Examinee>): ReportHeader_Examinee {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<ReportHeader_Examinee>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ReportHeader_Examinee): ReportHeader_Examinee {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* google.protobuf.StringValue name */ 1:
                    message.name = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.name);
                    break;
                case /* google.protobuf.StringValue gender */ 2:
                    message.gender = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.gender);
                    break;
                case /* google.protobuf.Int32Value age */ 3:
                    message.age = Int32Value.internalBinaryRead(reader, reader.uint32(), options, message.age);
                    break;
                case /* google.protobuf.Int32Value height */ 4:
                    message.height = Int32Value.internalBinaryRead(reader, reader.uint32(), options, message.height);
                    break;
                case /* google.protobuf.Int32Value weight */ 5:
                    message.weight = Int32Value.internalBinaryRead(reader, reader.uint32(), options, message.weight);
                    break;
                case /* google.protobuf.StringValue description */ 6:
                    message.description = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.description);
                    break;
                case /* google.protobuf.StringValue phone_number */ 10:
                    message.phoneNumber = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.phoneNumber);
                    break;
                case /* google.protobuf.StringValue id_number */ 11:
                    message.idNumber = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.idNumber);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ReportHeader_Examinee, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* google.protobuf.StringValue name = 1; */
        if (message.name)
            StringValue.internalBinaryWrite(message.name, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.StringValue gender = 2; */
        if (message.gender)
            StringValue.internalBinaryWrite(message.gender, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Int32Value age = 3; */
        if (message.age)
            Int32Value.internalBinaryWrite(message.age, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Int32Value height = 4; */
        if (message.height)
            Int32Value.internalBinaryWrite(message.height, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Int32Value weight = 5; */
        if (message.weight)
            Int32Value.internalBinaryWrite(message.weight, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.StringValue description = 6; */
        if (message.description)
            StringValue.internalBinaryWrite(message.description, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.StringValue phone_number = 10; */
        if (message.phoneNumber)
            StringValue.internalBinaryWrite(message.phoneNumber, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.StringValue id_number = 11; */
        if (message.idNumber)
            StringValue.internalBinaryWrite(message.idNumber, writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message algorithm.posture.ReportHeader.Examinee
 */
export const ReportHeader_Examinee = new ReportHeader_Examinee$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FacePoints$Type extends MessageType<FacePoints> {
    constructor() {
        super("algorithm.posture.FacePoints", [
            { no: 1, name: "nose", kind: "message", T: () => PointResult },
            { no: 9, name: "eye", kind: "message", T: () => PartResult },
            { no: 10, name: "ear", kind: "message", T: () => PartResult }
        ]);
    }
    create(value?: PartialMessage<FacePoints>): FacePoints {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<FacePoints>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: FacePoints): FacePoints {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* algorithm.posture.PointResult nose */ 1:
                    message.nose = PointResult.internalBinaryRead(reader, reader.uint32(), options, message.nose);
                    break;
                case /* algorithm.posture.PartResult eye */ 9:
                    message.eye = PartResult.internalBinaryRead(reader, reader.uint32(), options, message.eye);
                    break;
                case /* algorithm.posture.PartResult ear */ 10:
                    message.ear = PartResult.internalBinaryRead(reader, reader.uint32(), options, message.ear);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: FacePoints, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* algorithm.posture.PointResult nose = 1; */
        if (message.nose)
            PointResult.internalBinaryWrite(message.nose, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* algorithm.posture.PartResult eye = 9; */
        if (message.eye)
            PartResult.internalBinaryWrite(message.eye, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* algorithm.posture.PartResult ear = 10; */
        if (message.ear)
            PartResult.internalBinaryWrite(message.ear, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message algorithm.posture.FacePoints
 */
export const FacePoints = new FacePoints$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CosSecretResult$Type extends MessageType<CosSecretResult> {
    constructor() {
        super("algorithm.posture.CosSecretResult", [
            { no: 1, name: "secretId", kind: "message", T: () => StringValue },
            { no: 2, name: "secretKey", kind: "message", T: () => StringValue },
            { no: 3, name: "sessionToken", kind: "message", T: () => StringValue },
            { no: 4, name: "expirationTime", kind: "message", T: () => Int64Value }
        ]);
    }
    create(value?: PartialMessage<CosSecretResult>): CosSecretResult {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<CosSecretResult>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CosSecretResult): CosSecretResult {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* google.protobuf.StringValue secretId */ 1:
                    message.secretId = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.secretId);
                    break;
                case /* google.protobuf.StringValue secretKey */ 2:
                    message.secretKey = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.secretKey);
                    break;
                case /* google.protobuf.StringValue sessionToken */ 3:
                    message.sessionToken = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.sessionToken);
                    break;
                case /* google.protobuf.Int64Value expirationTime */ 4:
                    message.expirationTime = Int64Value.internalBinaryRead(reader, reader.uint32(), options, message.expirationTime);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CosSecretResult, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* google.protobuf.StringValue secretId = 1; */
        if (message.secretId)
            StringValue.internalBinaryWrite(message.secretId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.StringValue secretKey = 2; */
        if (message.secretKey)
            StringValue.internalBinaryWrite(message.secretKey, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.StringValue sessionToken = 3; */
        if (message.sessionToken)
            StringValue.internalBinaryWrite(message.sessionToken, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Int64Value expirationTime = 4; */
        if (message.expirationTime)
            Int64Value.internalBinaryWrite(message.expirationTime, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message algorithm.posture.CosSecretResult
 */
export const CosSecretResult = new CosSecretResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ResourceHandleResult$Type extends MessageType<ResourceHandleResult> {
    constructor() {
        super("algorithm.posture.ResourceHandleResult", [
            { no: 1, name: "bucket", kind: "message", T: () => StringValue },
            { no: 2, name: "region", kind: "message", T: () => StringValue },
            { no: 3, name: "frontKey", kind: "message", T: () => StringValue },
            { no: 4, name: "sideKey", kind: "message", T: () => StringValue },
            { no: 5, name: "bucketUrl", kind: "message", T: () => StringValue },
            { no: 6, name: "cosSecretResult", kind: "message", T: () => CosSecretResult }
        ]);
    }
    create(value?: PartialMessage<ResourceHandleResult>): ResourceHandleResult {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<ResourceHandleResult>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ResourceHandleResult): ResourceHandleResult {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* google.protobuf.StringValue bucket */ 1:
                    message.bucket = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.bucket);
                    break;
                case /* google.protobuf.StringValue region */ 2:
                    message.region = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.region);
                    break;
                case /* google.protobuf.StringValue frontKey */ 3:
                    message.frontKey = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.frontKey);
                    break;
                case /* google.protobuf.StringValue sideKey */ 4:
                    message.sideKey = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.sideKey);
                    break;
                case /* google.protobuf.StringValue bucketUrl */ 5:
                    message.bucketUrl = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.bucketUrl);
                    break;
                case /* algorithm.posture.CosSecretResult cosSecretResult */ 6:
                    message.cosSecretResult = CosSecretResult.internalBinaryRead(reader, reader.uint32(), options, message.cosSecretResult);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ResourceHandleResult, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* google.protobuf.StringValue bucket = 1; */
        if (message.bucket)
            StringValue.internalBinaryWrite(message.bucket, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.StringValue region = 2; */
        if (message.region)
            StringValue.internalBinaryWrite(message.region, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.StringValue frontKey = 3; */
        if (message.frontKey)
            StringValue.internalBinaryWrite(message.frontKey, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.StringValue sideKey = 4; */
        if (message.sideKey)
            StringValue.internalBinaryWrite(message.sideKey, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.StringValue bucketUrl = 5; */
        if (message.bucketUrl)
            StringValue.internalBinaryWrite(message.bucketUrl, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* algorithm.posture.CosSecretResult cosSecretResult = 6; */
        if (message.cosSecretResult)
            CosSecretResult.internalBinaryWrite(message.cosSecretResult, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message algorithm.posture.ResourceHandleResult
 */
export const ResourceHandleResult = new ResourceHandleResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class IssueLicenseRequest$Type extends MessageType<IssueLicenseRequest> {
    constructor() {
        super("algorithm.posture.IssueLicenseRequest", [
            { no: 1, name: "organizationId", kind: "scalar", T: 3 /*ScalarType.INT64*/ },
            { no: 2, name: "day", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "count", kind: "scalar", T: 3 /*ScalarType.INT64*/ }
        ]);
    }
    create(value?: PartialMessage<IssueLicenseRequest>): IssueLicenseRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.organizationId = "0";
        message.day = 0;
        message.count = "0";
        if (value !== undefined)
            reflectionMergePartial<IssueLicenseRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: IssueLicenseRequest): IssueLicenseRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 organizationId */ 1:
                    message.organizationId = reader.int64().toString();
                    break;
                case /* int32 day */ 2:
                    message.day = reader.int32();
                    break;
                case /* int64 count */ 3:
                    message.count = reader.int64().toString();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: IssueLicenseRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 organizationId = 1; */
        if (message.organizationId !== "0")
            writer.tag(1, WireType.Varint).int64(message.organizationId);
        /* int32 day = 2; */
        if (message.day !== 0)
            writer.tag(2, WireType.Varint).int32(message.day);
        /* int64 count = 3; */
        if (message.count !== "0")
            writer.tag(3, WireType.Varint).int64(message.count);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message algorithm.posture.IssueLicenseRequest
 */
export const IssueLicenseRequest = new IssueLicenseRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class IssueLicenseResponse$Type extends MessageType<IssueLicenseResponse> {
    constructor() {
        super("algorithm.posture.IssueLicenseResponse", [
            { no: 1, name: "licenseId", kind: "scalar", T: 3 /*ScalarType.INT64*/ }
        ]);
    }
    create(value?: PartialMessage<IssueLicenseResponse>): IssueLicenseResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.licenseId = "0";
        if (value !== undefined)
            reflectionMergePartial<IssueLicenseResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: IssueLicenseResponse): IssueLicenseResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 licenseId */ 1:
                    message.licenseId = reader.int64().toString();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: IssueLicenseResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 licenseId = 1; */
        if (message.licenseId !== "0")
            writer.tag(1, WireType.Varint).int64(message.licenseId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message algorithm.posture.IssueLicenseResponse
 */
export const IssueLicenseResponse = new IssueLicenseResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class IssueOrganizationLicenseRequest$Type extends MessageType<IssueOrganizationLicenseRequest> {
    constructor() {
        super("algorithm.posture.IssueOrganizationLicenseRequest", [
            { no: 1, name: "organization_id", kind: "scalar", T: 3 /*ScalarType.INT64*/ },
            { no: 2, name: "expired_at", kind: "message", T: () => Timestamp },
            { no: 3, name: "times", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "client", kind: "message", T: () => StringValue }
        ]);
    }
    create(value?: PartialMessage<IssueOrganizationLicenseRequest>): IssueOrganizationLicenseRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.organizationId = "0";
        message.times = 0;
        if (value !== undefined)
            reflectionMergePartial<IssueOrganizationLicenseRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: IssueOrganizationLicenseRequest): IssueOrganizationLicenseRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 organization_id */ 1:
                    message.organizationId = reader.int64().toString();
                    break;
                case /* google.protobuf.Timestamp expired_at */ 2:
                    message.expiredAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.expiredAt);
                    break;
                case /* int32 times */ 3:
                    message.times = reader.int32();
                    break;
                case /* google.protobuf.StringValue client = 4 [deprecated = true] */ 4:
                    message.client = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.client);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: IssueOrganizationLicenseRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 organization_id = 1; */
        if (message.organizationId !== "0")
            writer.tag(1, WireType.Varint).int64(message.organizationId);
        /* google.protobuf.Timestamp expired_at = 2; */
        if (message.expiredAt)
            Timestamp.internalBinaryWrite(message.expiredAt, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* int32 times = 3; */
        if (message.times !== 0)
            writer.tag(3, WireType.Varint).int32(message.times);
        /* google.protobuf.StringValue client = 4 [deprecated = true]; */
        if (message.client)
            StringValue.internalBinaryWrite(message.client, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message algorithm.posture.IssueOrganizationLicenseRequest
 */
export const IssueOrganizationLicenseRequest = new IssueOrganizationLicenseRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class IssueOrganizationLicenseResponse$Type extends MessageType<IssueOrganizationLicenseResponse> {
    constructor() {
        super("algorithm.posture.IssueOrganizationLicenseResponse", [
            { no: 1, name: "license_id", kind: "scalar", T: 3 /*ScalarType.INT64*/ }
        ]);
    }
    create(value?: PartialMessage<IssueOrganizationLicenseResponse>): IssueOrganizationLicenseResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.licenseId = "0";
        if (value !== undefined)
            reflectionMergePartial<IssueOrganizationLicenseResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: IssueOrganizationLicenseResponse): IssueOrganizationLicenseResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 license_id */ 1:
                    message.licenseId = reader.int64().toString();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: IssueOrganizationLicenseResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 license_id = 1; */
        if (message.licenseId !== "0")
            writer.tag(1, WireType.Varint).int64(message.licenseId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message algorithm.posture.IssueOrganizationLicenseResponse
 */
export const IssueOrganizationLicenseResponse = new IssueOrganizationLicenseResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class IssueAccountLicenseRequest$Type extends MessageType<IssueAccountLicenseRequest> {
    constructor() {
        super("algorithm.posture.IssueAccountLicenseRequest", [
            { no: 2, name: "day", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "count", kind: "scalar", T: 3 /*ScalarType.INT64*/ },
            { no: 4, name: "accountId", kind: "scalar", T: 3 /*ScalarType.INT64*/ },
            { no: 5, name: "client", kind: "message", T: () => StringValue }
        ]);
    }
    create(value?: PartialMessage<IssueAccountLicenseRequest>): IssueAccountLicenseRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.day = 0;
        message.count = "0";
        message.accountId = "0";
        if (value !== undefined)
            reflectionMergePartial<IssueAccountLicenseRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: IssueAccountLicenseRequest): IssueAccountLicenseRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 day */ 2:
                    message.day = reader.int32();
                    break;
                case /* int64 count */ 3:
                    message.count = reader.int64().toString();
                    break;
                case /* int64 accountId */ 4:
                    message.accountId = reader.int64().toString();
                    break;
                case /* google.protobuf.StringValue client */ 5:
                    message.client = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.client);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: IssueAccountLicenseRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 day = 2; */
        if (message.day !== 0)
            writer.tag(2, WireType.Varint).int32(message.day);
        /* int64 count = 3; */
        if (message.count !== "0")
            writer.tag(3, WireType.Varint).int64(message.count);
        /* int64 accountId = 4; */
        if (message.accountId !== "0")
            writer.tag(4, WireType.Varint).int64(message.accountId);
        /* google.protobuf.StringValue client = 5; */
        if (message.client)
            StringValue.internalBinaryWrite(message.client, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message algorithm.posture.IssueAccountLicenseRequest
 */
export const IssueAccountLicenseRequest = new IssueAccountLicenseRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class IssueAccountLicenseResponse$Type extends MessageType<IssueAccountLicenseResponse> {
    constructor() {
        super("algorithm.posture.IssueAccountLicenseResponse", [
            { no: 1, name: "licenseId", kind: "scalar", T: 3 /*ScalarType.INT64*/ }
        ]);
    }
    create(value?: PartialMessage<IssueAccountLicenseResponse>): IssueAccountLicenseResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.licenseId = "0";
        if (value !== undefined)
            reflectionMergePartial<IssueAccountLicenseResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: IssueAccountLicenseResponse): IssueAccountLicenseResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 licenseId */ 1:
                    message.licenseId = reader.int64().toString();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: IssueAccountLicenseResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 licenseId = 1; */
        if (message.licenseId !== "0")
            writer.tag(1, WireType.Varint).int64(message.licenseId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message algorithm.posture.IssueAccountLicenseResponse
 */
export const IssueAccountLicenseResponse = new IssueAccountLicenseResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetRiskDetailByRiskIdsResponse$Type extends MessageType<GetRiskDetailByRiskIdsResponse> {
    constructor() {
        super("algorithm.posture.GetRiskDetailByRiskIdsResponse", [
            { no: 1, name: "riskDetailResults", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => RiskDetailResult }
        ]);
    }
    create(value?: PartialMessage<GetRiskDetailByRiskIdsResponse>): GetRiskDetailByRiskIdsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.riskDetailResults = [];
        if (value !== undefined)
            reflectionMergePartial<GetRiskDetailByRiskIdsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetRiskDetailByRiskIdsResponse): GetRiskDetailByRiskIdsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated algorithm.posture.RiskDetailResult riskDetailResults */ 1:
                    message.riskDetailResults.push(RiskDetailResult.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetRiskDetailByRiskIdsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated algorithm.posture.RiskDetailResult riskDetailResults = 1; */
        for (let i = 0; i < message.riskDetailResults.length; i++)
            RiskDetailResult.internalBinaryWrite(message.riskDetailResults[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message algorithm.posture.GetRiskDetailByRiskIdsResponse
 */
export const GetRiskDetailByRiskIdsResponse = new GetRiskDetailByRiskIdsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RiskDetailResult$Type extends MessageType<RiskDetailResult> {
    constructor() {
        super("algorithm.posture.RiskDetailResult", [
            { no: 1, name: "riskId", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 9, name: "trainings", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => TagResult },
            { no: 10, name: "attentions", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => TagResult },
            { no: 11, name: "reasons", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ResultResult },
            { no: 12, name: "risks", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ResultResult }
        ]);
    }
    create(value?: PartialMessage<RiskDetailResult>): RiskDetailResult {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.riskId = 0;
        message.trainings = [];
        message.attentions = [];
        message.reasons = [];
        message.risks = [];
        if (value !== undefined)
            reflectionMergePartial<RiskDetailResult>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RiskDetailResult): RiskDetailResult {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 riskId */ 1:
                    message.riskId = reader.int32();
                    break;
                case /* repeated algorithm.posture.TagResult trainings */ 9:
                    message.trainings.push(TagResult.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated algorithm.posture.TagResult attentions */ 10:
                    message.attentions.push(TagResult.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated algorithm.posture.ResultResult reasons */ 11:
                    message.reasons.push(ResultResult.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated algorithm.posture.ResultResult risks */ 12:
                    message.risks.push(ResultResult.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RiskDetailResult, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 riskId = 1; */
        if (message.riskId !== 0)
            writer.tag(1, WireType.Varint).int32(message.riskId);
        /* repeated algorithm.posture.TagResult trainings = 9; */
        for (let i = 0; i < message.trainings.length; i++)
            TagResult.internalBinaryWrite(message.trainings[i], writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* repeated algorithm.posture.TagResult attentions = 10; */
        for (let i = 0; i < message.attentions.length; i++)
            TagResult.internalBinaryWrite(message.attentions[i], writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* repeated algorithm.posture.ResultResult reasons = 11; */
        for (let i = 0; i < message.reasons.length; i++)
            ResultResult.internalBinaryWrite(message.reasons[i], writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        /* repeated algorithm.posture.ResultResult risks = 12; */
        for (let i = 0; i < message.risks.length; i++)
            ResultResult.internalBinaryWrite(message.risks[i], writer.tag(12, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message algorithm.posture.RiskDetailResult
 */
export const RiskDetailResult = new RiskDetailResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetRiskDetailByRiskIdsRequest$Type extends MessageType<GetRiskDetailByRiskIdsRequest> {
    constructor() {
        super("algorithm.posture.GetRiskDetailByRiskIdsRequest", [
            { no: 1, name: "riskDetailInfos", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => RiskDetailInfo },
            { no: 2, name: "language", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "organizationId", kind: "message", T: () => Int64Value }
        ]);
    }
    create(value?: PartialMessage<GetRiskDetailByRiskIdsRequest>): GetRiskDetailByRiskIdsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.riskDetailInfos = [];
        message.language = "";
        if (value !== undefined)
            reflectionMergePartial<GetRiskDetailByRiskIdsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetRiskDetailByRiskIdsRequest): GetRiskDetailByRiskIdsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated algorithm.posture.RiskDetailInfo riskDetailInfos */ 1:
                    message.riskDetailInfos.push(RiskDetailInfo.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string language */ 2:
                    message.language = reader.string();
                    break;
                case /* google.protobuf.Int64Value organizationId */ 3:
                    message.organizationId = Int64Value.internalBinaryRead(reader, reader.uint32(), options, message.organizationId);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetRiskDetailByRiskIdsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated algorithm.posture.RiskDetailInfo riskDetailInfos = 1; */
        for (let i = 0; i < message.riskDetailInfos.length; i++)
            RiskDetailInfo.internalBinaryWrite(message.riskDetailInfos[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string language = 2; */
        if (message.language !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.language);
        /* google.protobuf.Int64Value organizationId = 3; */
        if (message.organizationId)
            Int64Value.internalBinaryWrite(message.organizationId, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message algorithm.posture.GetRiskDetailByRiskIdsRequest
 */
export const GetRiskDetailByRiskIdsRequest = new GetRiskDetailByRiskIdsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RiskDetailInfo$Type extends MessageType<RiskDetailInfo> {
    constructor() {
        super("algorithm.posture.RiskDetailInfo", [
            { no: 1, name: "riskId", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "riskName", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<RiskDetailInfo>): RiskDetailInfo {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.riskId = 0;
        message.riskName = "";
        if (value !== undefined)
            reflectionMergePartial<RiskDetailInfo>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RiskDetailInfo): RiskDetailInfo {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 riskId */ 1:
                    message.riskId = reader.int32();
                    break;
                case /* string riskName */ 2:
                    message.riskName = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RiskDetailInfo, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 riskId = 1; */
        if (message.riskId !== 0)
            writer.tag(1, WireType.Varint).int32(message.riskId);
        /* string riskName = 2; */
        if (message.riskName !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.riskName);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message algorithm.posture.RiskDetailInfo
 */
export const RiskDetailInfo = new RiskDetailInfo$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UploadPostureCallbackRequest$Type extends MessageType<UploadPostureCallbackRequest> {
    constructor() {
        super("algorithm.posture.UploadPostureCallbackRequest", [
            { no: 2, name: "code", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "message", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<UploadPostureCallbackRequest>): UploadPostureCallbackRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.code = 0;
        message.id = "";
        message.message = "";
        if (value !== undefined)
            reflectionMergePartial<UploadPostureCallbackRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UploadPostureCallbackRequest): UploadPostureCallbackRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 code */ 2:
                    message.code = reader.int32();
                    break;
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string message */ 4:
                    message.message = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UploadPostureCallbackRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* int32 code = 2; */
        if (message.code !== 0)
            writer.tag(2, WireType.Varint).int32(message.code);
        /* string message = 4; */
        if (message.message !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.message);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message algorithm.posture.UploadPostureCallbackRequest
 */
export const UploadPostureCallbackRequest = new UploadPostureCallbackRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BodyReplyResult$Type extends MessageType<BodyReplyResult> {
    constructor() {
        super("algorithm.posture.BodyReplyResult", [
            { no: 1, name: "uuid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "front", kind: "message", T: () => ConclusionReplyResult },
            { no: 4, name: "side", kind: "message", T: () => ConclusionReplyResult }
        ]);
    }
    create(value?: PartialMessage<BodyReplyResult>): BodyReplyResult {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.uuid = "";
        if (value !== undefined)
            reflectionMergePartial<BodyReplyResult>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: BodyReplyResult): BodyReplyResult {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string uuid */ 1:
                    message.uuid = reader.string();
                    break;
                case /* algorithm.posture.ConclusionReplyResult front */ 2:
                    message.front = ConclusionReplyResult.internalBinaryRead(reader, reader.uint32(), options, message.front);
                    break;
                case /* algorithm.posture.ConclusionReplyResult side */ 4:
                    message.side = ConclusionReplyResult.internalBinaryRead(reader, reader.uint32(), options, message.side);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: BodyReplyResult, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string uuid = 1; */
        if (message.uuid !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.uuid);
        /* algorithm.posture.ConclusionReplyResult front = 2; */
        if (message.front)
            ConclusionReplyResult.internalBinaryWrite(message.front, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* algorithm.posture.ConclusionReplyResult side = 4; */
        if (message.side)
            ConclusionReplyResult.internalBinaryWrite(message.side, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message algorithm.posture.BodyReplyResult
 */
export const BodyReplyResult = new BodyReplyResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConclusionReplyResult$Type extends MessageType<ConclusionReplyResult> {
    constructor() {
        super("algorithm.posture.ConclusionReplyResult", [
            { no: 1, name: "valid", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "cause", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "body", kind: "message", T: () => PointsResult },
            { no: 4, name: "angle", kind: "enum", T: () => ["algorithm.posture.ConclusionReplyResult.ShootingAngle", ConclusionReplyResult_ShootingAngle] },
            { no: 5, name: "risks", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => RiskReplyResult }
        ]);
    }
    create(value?: PartialMessage<ConclusionReplyResult>): ConclusionReplyResult {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.valid = false;
        message.cause = "";
        message.angle = 0;
        message.risks = [];
        if (value !== undefined)
            reflectionMergePartial<ConclusionReplyResult>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ConclusionReplyResult): ConclusionReplyResult {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool valid */ 1:
                    message.valid = reader.bool();
                    break;
                case /* string cause */ 2:
                    message.cause = reader.string();
                    break;
                case /* algorithm.posture.PointsResult body */ 3:
                    message.body = PointsResult.internalBinaryRead(reader, reader.uint32(), options, message.body);
                    break;
                case /* algorithm.posture.ConclusionReplyResult.ShootingAngle angle */ 4:
                    message.angle = reader.int32();
                    break;
                case /* repeated algorithm.posture.RiskReplyResult risks */ 5:
                    message.risks.push(RiskReplyResult.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ConclusionReplyResult, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool valid = 1; */
        if (message.valid !== false)
            writer.tag(1, WireType.Varint).bool(message.valid);
        /* string cause = 2; */
        if (message.cause !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.cause);
        /* algorithm.posture.PointsResult body = 3; */
        if (message.body)
            PointsResult.internalBinaryWrite(message.body, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* algorithm.posture.ConclusionReplyResult.ShootingAngle angle = 4; */
        if (message.angle !== 0)
            writer.tag(4, WireType.Varint).int32(message.angle);
        /* repeated algorithm.posture.RiskReplyResult risks = 5; */
        for (let i = 0; i < message.risks.length; i++)
            RiskReplyResult.internalBinaryWrite(message.risks[i], writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message algorithm.posture.ConclusionReplyResult
 */
export const ConclusionReplyResult = new ConclusionReplyResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RiskReplyResult$Type extends MessageType<RiskReplyResult> {
    constructor() {
        super("algorithm.posture.RiskReplyResult", [
            { no: 1, name: "valid", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "key", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "measurement", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 5, name: "score", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 6, name: "level", kind: "enum", T: () => ["algorithm.posture.Level", Level] },
            { no: 7, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "supplement", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "side", kind: "enum", T: () => ["algorithm.posture.Side", Side] }
        ]);
    }
    create(value?: PartialMessage<RiskReplyResult>): RiskReplyResult {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.valid = false;
        message.key = "";
        message.name = "";
        message.measurement = 0;
        message.score = 0;
        message.level = 0;
        message.description = "";
        message.supplement = "";
        message.side = 0;
        if (value !== undefined)
            reflectionMergePartial<RiskReplyResult>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RiskReplyResult): RiskReplyResult {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool valid */ 1:
                    message.valid = reader.bool();
                    break;
                case /* string key */ 2:
                    message.key = reader.string();
                    break;
                case /* string name */ 3:
                    message.name = reader.string();
                    break;
                case /* double measurement */ 4:
                    message.measurement = reader.double();
                    break;
                case /* double score */ 5:
                    message.score = reader.double();
                    break;
                case /* algorithm.posture.Level level */ 6:
                    message.level = reader.int32();
                    break;
                case /* string description */ 7:
                    message.description = reader.string();
                    break;
                case /* string supplement */ 8:
                    message.supplement = reader.string();
                    break;
                case /* algorithm.posture.Side side */ 9:
                    message.side = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RiskReplyResult, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool valid = 1; */
        if (message.valid !== false)
            writer.tag(1, WireType.Varint).bool(message.valid);
        /* string key = 2; */
        if (message.key !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.key);
        /* string name = 3; */
        if (message.name !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.name);
        /* double measurement = 4; */
        if (message.measurement !== 0)
            writer.tag(4, WireType.Bit64).double(message.measurement);
        /* double score = 5; */
        if (message.score !== 0)
            writer.tag(5, WireType.Bit64).double(message.score);
        /* algorithm.posture.Level level = 6; */
        if (message.level !== 0)
            writer.tag(6, WireType.Varint).int32(message.level);
        /* string description = 7; */
        if (message.description !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.description);
        /* string supplement = 8; */
        if (message.supplement !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.supplement);
        /* algorithm.posture.Side side = 9; */
        if (message.side !== 0)
            writer.tag(9, WireType.Varint).int32(message.side);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message algorithm.posture.RiskReplyResult
 */
export const RiskReplyResult = new RiskReplyResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BodyResult$Type extends MessageType<BodyResult> {
    constructor() {
        super("algorithm.posture.BodyResult", [
            { no: 3, name: "front", kind: "message", T: () => ItemResult },
            { no: 4, name: "side", kind: "message", T: () => ItemResult },
            { no: 5, name: "back", kind: "message", T: () => ItemResult },
            { no: 6, name: "other_side", kind: "message", T: () => ItemResult }
        ]);
    }
    create(value?: PartialMessage<BodyResult>): BodyResult {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<BodyResult>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: BodyResult): BodyResult {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* algorithm.posture.ItemResult front */ 3:
                    message.front = ItemResult.internalBinaryRead(reader, reader.uint32(), options, message.front);
                    break;
                case /* algorithm.posture.ItemResult side */ 4:
                    message.side = ItemResult.internalBinaryRead(reader, reader.uint32(), options, message.side);
                    break;
                case /* algorithm.posture.ItemResult back */ 5:
                    message.back = ItemResult.internalBinaryRead(reader, reader.uint32(), options, message.back);
                    break;
                case /* algorithm.posture.ItemResult other_side */ 6:
                    message.otherSide = ItemResult.internalBinaryRead(reader, reader.uint32(), options, message.otherSide);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: BodyResult, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* algorithm.posture.ItemResult front = 3; */
        if (message.front)
            ItemResult.internalBinaryWrite(message.front, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* algorithm.posture.ItemResult side = 4; */
        if (message.side)
            ItemResult.internalBinaryWrite(message.side, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* algorithm.posture.ItemResult back = 5; */
        if (message.back)
            ItemResult.internalBinaryWrite(message.back, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* algorithm.posture.ItemResult other_side = 6; */
        if (message.otherSide)
            ItemResult.internalBinaryWrite(message.otherSide, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message algorithm.posture.BodyResult
 */
export const BodyResult = new BodyResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UploadPostureCallbackResponse$Type extends MessageType<UploadPostureCallbackResponse> {
    constructor() {
        super("algorithm.posture.UploadPostureCallbackResponse", [
            { no: 1, name: "success", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<UploadPostureCallbackResponse>): UploadPostureCallbackResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.success = false;
        if (value !== undefined)
            reflectionMergePartial<UploadPostureCallbackResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UploadPostureCallbackResponse): UploadPostureCallbackResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool success */ 1:
                    message.success = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UploadPostureCallbackResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool success = 1; */
        if (message.success !== false)
            writer.tag(1, WireType.Varint).bool(message.success);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message algorithm.posture.UploadPostureCallbackResponse
 */
export const UploadPostureCallbackResponse = new UploadPostureCallbackResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UploadPostureRequest$Type extends MessageType<UploadPostureRequest> {
    constructor() {
        super("algorithm.posture.UploadPostureRequest", [
            { no: 1, name: "frontKey", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "sideKey", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "bucketUrl", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "backKey", kind: "message", T: () => StringValue },
            { no: 5, name: "organizationId", kind: "message", T: () => Int64Value },
            { no: 6, name: "client", kind: "message", T: () => StringValue },
            { no: 7, name: "other_side_key", kind: "message", T: () => StringValue },
            { no: 11, name: "max_atr_angle", kind: "message", T: () => DoubleValue },
            { no: 12, name: "back_heel", kind: "message", T: () => PartResult },
            { no: 13, name: "depth_data", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UploadPostureRequest_DepthData }
        ]);
    }
    create(value?: PartialMessage<UploadPostureRequest>): UploadPostureRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.frontKey = "";
        message.sideKey = "";
        message.bucketUrl = "";
        message.depthData = [];
        if (value !== undefined)
            reflectionMergePartial<UploadPostureRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UploadPostureRequest): UploadPostureRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string frontKey */ 1:
                    message.frontKey = reader.string();
                    break;
                case /* string sideKey */ 2:
                    message.sideKey = reader.string();
                    break;
                case /* string bucketUrl */ 3:
                    message.bucketUrl = reader.string();
                    break;
                case /* google.protobuf.StringValue backKey */ 4:
                    message.backKey = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.backKey);
                    break;
                case /* google.protobuf.Int64Value organizationId */ 5:
                    message.organizationId = Int64Value.internalBinaryRead(reader, reader.uint32(), options, message.organizationId);
                    break;
                case /* google.protobuf.StringValue client */ 6:
                    message.client = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.client);
                    break;
                case /* google.protobuf.StringValue other_side_key */ 7:
                    message.otherSideKey = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.otherSideKey);
                    break;
                case /* google.protobuf.DoubleValue max_atr_angle */ 11:
                    message.maxAtrAngle = DoubleValue.internalBinaryRead(reader, reader.uint32(), options, message.maxAtrAngle);
                    break;
                case /* algorithm.posture.PartResult back_heel */ 12:
                    message.backHeel = PartResult.internalBinaryRead(reader, reader.uint32(), options, message.backHeel);
                    break;
                case /* repeated algorithm.posture.UploadPostureRequest.DepthData depth_data */ 13:
                    message.depthData.push(UploadPostureRequest_DepthData.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UploadPostureRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string frontKey = 1; */
        if (message.frontKey !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.frontKey);
        /* string sideKey = 2; */
        if (message.sideKey !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.sideKey);
        /* string bucketUrl = 3; */
        if (message.bucketUrl !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.bucketUrl);
        /* google.protobuf.StringValue backKey = 4; */
        if (message.backKey)
            StringValue.internalBinaryWrite(message.backKey, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Int64Value organizationId = 5; */
        if (message.organizationId)
            Int64Value.internalBinaryWrite(message.organizationId, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.StringValue client = 6; */
        if (message.client)
            StringValue.internalBinaryWrite(message.client, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.StringValue other_side_key = 7; */
        if (message.otherSideKey)
            StringValue.internalBinaryWrite(message.otherSideKey, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.DoubleValue max_atr_angle = 11; */
        if (message.maxAtrAngle)
            DoubleValue.internalBinaryWrite(message.maxAtrAngle, writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        /* algorithm.posture.PartResult back_heel = 12; */
        if (message.backHeel)
            PartResult.internalBinaryWrite(message.backHeel, writer.tag(12, WireType.LengthDelimited).fork(), options).join();
        /* repeated algorithm.posture.UploadPostureRequest.DepthData depth_data = 13; */
        for (let i = 0; i < message.depthData.length; i++)
            UploadPostureRequest_DepthData.internalBinaryWrite(message.depthData[i], writer.tag(13, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message algorithm.posture.UploadPostureRequest
 */
export const UploadPostureRequest = new UploadPostureRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UploadPostureRequest_DepthData$Type extends MessageType<UploadPostureRequest_DepthData> {
    constructor() {
        super("algorithm.posture.UploadPostureRequest.DepthData", [
            { no: 1, name: "shooting_angle", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "intrinsics", kind: "message", T: () => UploadPostureRequest_Intrinsics },
            { no: 3, name: "depth_image_key", kind: "message", T: () => StringValue },
            { no: 4, name: "contour_map_moire_image_key", kind: "message", T: () => StringValue }
        ]);
    }
    create(value?: PartialMessage<UploadPostureRequest_DepthData>): UploadPostureRequest_DepthData {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.shootingAngle = "";
        if (value !== undefined)
            reflectionMergePartial<UploadPostureRequest_DepthData>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UploadPostureRequest_DepthData): UploadPostureRequest_DepthData {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string shooting_angle */ 1:
                    message.shootingAngle = reader.string();
                    break;
                case /* algorithm.posture.UploadPostureRequest.Intrinsics intrinsics */ 2:
                    message.intrinsics = UploadPostureRequest_Intrinsics.internalBinaryRead(reader, reader.uint32(), options, message.intrinsics);
                    break;
                case /* google.protobuf.StringValue depth_image_key */ 3:
                    message.depthImageKey = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.depthImageKey);
                    break;
                case /* google.protobuf.StringValue contour_map_moire_image_key */ 4:
                    message.contourMapMoireImageKey = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.contourMapMoireImageKey);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UploadPostureRequest_DepthData, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string shooting_angle = 1; */
        if (message.shootingAngle !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.shootingAngle);
        /* algorithm.posture.UploadPostureRequest.Intrinsics intrinsics = 2; */
        if (message.intrinsics)
            UploadPostureRequest_Intrinsics.internalBinaryWrite(message.intrinsics, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.StringValue depth_image_key = 3; */
        if (message.depthImageKey)
            StringValue.internalBinaryWrite(message.depthImageKey, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.StringValue contour_map_moire_image_key = 4; */
        if (message.contourMapMoireImageKey)
            StringValue.internalBinaryWrite(message.contourMapMoireImageKey, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message algorithm.posture.UploadPostureRequest.DepthData
 */
export const UploadPostureRequest_DepthData = new UploadPostureRequest_DepthData$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UploadPostureRequest_Intrinsics$Type extends MessageType<UploadPostureRequest_Intrinsics> {
    constructor() {
        super("algorithm.posture.UploadPostureRequest.Intrinsics", [
            { no: 1, name: "fx", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 2, name: "fy", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 3, name: "cx", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 4, name: "cy", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ }
        ]);
    }
    create(value?: PartialMessage<UploadPostureRequest_Intrinsics>): UploadPostureRequest_Intrinsics {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.fx = 0;
        message.fy = 0;
        message.cx = 0;
        message.cy = 0;
        if (value !== undefined)
            reflectionMergePartial<UploadPostureRequest_Intrinsics>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UploadPostureRequest_Intrinsics): UploadPostureRequest_Intrinsics {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* double fx */ 1:
                    message.fx = reader.double();
                    break;
                case /* double fy */ 2:
                    message.fy = reader.double();
                    break;
                case /* double cx */ 3:
                    message.cx = reader.double();
                    break;
                case /* double cy */ 4:
                    message.cy = reader.double();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UploadPostureRequest_Intrinsics, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* double fx = 1; */
        if (message.fx !== 0)
            writer.tag(1, WireType.Bit64).double(message.fx);
        /* double fy = 2; */
        if (message.fy !== 0)
            writer.tag(2, WireType.Bit64).double(message.fy);
        /* double cx = 3; */
        if (message.cx !== 0)
            writer.tag(3, WireType.Bit64).double(message.cx);
        /* double cy = 4; */
        if (message.cy !== 0)
            writer.tag(4, WireType.Bit64).double(message.cy);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message algorithm.posture.UploadPostureRequest.Intrinsics
 */
export const UploadPostureRequest_Intrinsics = new UploadPostureRequest_Intrinsics$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UploadPostureResponse$Type extends MessageType<UploadPostureResponse> {
    constructor() {
        super("algorithm.posture.UploadPostureResponse", [
            { no: 1, name: "uuid", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<UploadPostureResponse>): UploadPostureResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.uuid = "";
        if (value !== undefined)
            reflectionMergePartial<UploadPostureResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UploadPostureResponse): UploadPostureResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string uuid */ 1:
                    message.uuid = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UploadPostureResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string uuid = 1; */
        if (message.uuid !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.uuid);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message algorithm.posture.UploadPostureResponse
 */
export const UploadPostureResponse = new UploadPostureResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetPostureReportRequest$Type extends MessageType<GetPostureReportRequest> {
    constructor() {
        super("algorithm.posture.GetPostureReportRequest", [
            { no: 1, name: "uuid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "language", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "organizationId", kind: "message", T: () => Int64Value }
        ]);
    }
    create(value?: PartialMessage<GetPostureReportRequest>): GetPostureReportRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.uuid = "";
        message.language = "";
        if (value !== undefined)
            reflectionMergePartial<GetPostureReportRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetPostureReportRequest): GetPostureReportRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string uuid */ 1:
                    message.uuid = reader.string();
                    break;
                case /* string language */ 2:
                    message.language = reader.string();
                    break;
                case /* google.protobuf.Int64Value organizationId */ 3:
                    message.organizationId = Int64Value.internalBinaryRead(reader, reader.uint32(), options, message.organizationId);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetPostureReportRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string uuid = 1; */
        if (message.uuid !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.uuid);
        /* string language = 2; */
        if (message.language !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.language);
        /* google.protobuf.Int64Value organizationId = 3; */
        if (message.organizationId)
            Int64Value.internalBinaryWrite(message.organizationId, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message algorithm.posture.GetPostureReportRequest
 */
export const GetPostureReportRequest = new GetPostureReportRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetPostureReportResponse$Type extends MessageType<GetPostureReportResponse> {
    constructor() {
        super("algorithm.posture.GetPostureReportResponse", [
            { no: 1, name: "uuid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "front", kind: "message", T: () => StringValue },
            { no: 3, name: "side", kind: "message", T: () => StringValue },
            { no: 4, name: "success", kind: "message", T: () => BoolValue },
            { no: 5, name: "body", kind: "message", T: () => BodyResult },
            { no: 6, name: "status", kind: "message", T: () => StringValue },
            { no: 7, name: "resultPosture", kind: "message", T: () => StringValue },
            { no: 8, name: "general", kind: "message", T: () => GeneralResult },
            { no: 9, name: "trainings", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => TagResult },
            { no: 10, name: "attentions", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => TagResult },
            { no: 11, name: "reasons", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ResultResult },
            { no: 12, name: "risks", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ResultResult },
            { no: 13, name: "back", kind: "message", T: () => StringValue },
            { no: 14, name: "other_side", kind: "message", T: () => StringValue },
            { no: 16, name: "urlForShare", kind: "message", T: () => StringValue },
            { no: 17, name: "urlForLocal", kind: "message", T: () => StringValue },
            { no: 21, name: "max_atr_angle", kind: "message", T: () => DoubleValue },
            { no: 22, name: "depth_data", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => GetPostureReportResponse_DepthData }
        ]);
    }
    create(value?: PartialMessage<GetPostureReportResponse>): GetPostureReportResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.uuid = "";
        message.trainings = [];
        message.attentions = [];
        message.reasons = [];
        message.risks = [];
        message.depthData = [];
        if (value !== undefined)
            reflectionMergePartial<GetPostureReportResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetPostureReportResponse): GetPostureReportResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string uuid */ 1:
                    message.uuid = reader.string();
                    break;
                case /* google.protobuf.StringValue front */ 2:
                    message.front = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.front);
                    break;
                case /* google.protobuf.StringValue side */ 3:
                    message.side = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.side);
                    break;
                case /* google.protobuf.BoolValue success */ 4:
                    message.success = BoolValue.internalBinaryRead(reader, reader.uint32(), options, message.success);
                    break;
                case /* algorithm.posture.BodyResult body */ 5:
                    message.body = BodyResult.internalBinaryRead(reader, reader.uint32(), options, message.body);
                    break;
                case /* google.protobuf.StringValue status */ 6:
                    message.status = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.status);
                    break;
                case /* google.protobuf.StringValue resultPosture */ 7:
                    message.resultPosture = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.resultPosture);
                    break;
                case /* algorithm.posture.GeneralResult general */ 8:
                    message.general = GeneralResult.internalBinaryRead(reader, reader.uint32(), options, message.general);
                    break;
                case /* repeated algorithm.posture.TagResult trainings */ 9:
                    message.trainings.push(TagResult.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated algorithm.posture.TagResult attentions */ 10:
                    message.attentions.push(TagResult.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated algorithm.posture.ResultResult reasons */ 11:
                    message.reasons.push(ResultResult.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated algorithm.posture.ResultResult risks */ 12:
                    message.risks.push(ResultResult.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* google.protobuf.StringValue back */ 13:
                    message.back = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.back);
                    break;
                case /* google.protobuf.StringValue other_side */ 14:
                    message.otherSide = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.otherSide);
                    break;
                case /* google.protobuf.StringValue urlForShare */ 16:
                    message.urlForShare = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.urlForShare);
                    break;
                case /* google.protobuf.StringValue urlForLocal */ 17:
                    message.urlForLocal = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.urlForLocal);
                    break;
                case /* google.protobuf.DoubleValue max_atr_angle */ 21:
                    message.maxAtrAngle = DoubleValue.internalBinaryRead(reader, reader.uint32(), options, message.maxAtrAngle);
                    break;
                case /* repeated algorithm.posture.GetPostureReportResponse.DepthData depth_data */ 22:
                    message.depthData.push(GetPostureReportResponse_DepthData.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetPostureReportResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string uuid = 1; */
        if (message.uuid !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.uuid);
        /* google.protobuf.StringValue front = 2; */
        if (message.front)
            StringValue.internalBinaryWrite(message.front, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.StringValue side = 3; */
        if (message.side)
            StringValue.internalBinaryWrite(message.side, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.BoolValue success = 4; */
        if (message.success)
            BoolValue.internalBinaryWrite(message.success, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* algorithm.posture.BodyResult body = 5; */
        if (message.body)
            BodyResult.internalBinaryWrite(message.body, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.StringValue status = 6; */
        if (message.status)
            StringValue.internalBinaryWrite(message.status, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.StringValue resultPosture = 7; */
        if (message.resultPosture)
            StringValue.internalBinaryWrite(message.resultPosture, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* algorithm.posture.GeneralResult general = 8; */
        if (message.general)
            GeneralResult.internalBinaryWrite(message.general, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* repeated algorithm.posture.TagResult trainings = 9; */
        for (let i = 0; i < message.trainings.length; i++)
            TagResult.internalBinaryWrite(message.trainings[i], writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* repeated algorithm.posture.TagResult attentions = 10; */
        for (let i = 0; i < message.attentions.length; i++)
            TagResult.internalBinaryWrite(message.attentions[i], writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* repeated algorithm.posture.ResultResult reasons = 11; */
        for (let i = 0; i < message.reasons.length; i++)
            ResultResult.internalBinaryWrite(message.reasons[i], writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        /* repeated algorithm.posture.ResultResult risks = 12; */
        for (let i = 0; i < message.risks.length; i++)
            ResultResult.internalBinaryWrite(message.risks[i], writer.tag(12, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.StringValue back = 13; */
        if (message.back)
            StringValue.internalBinaryWrite(message.back, writer.tag(13, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.StringValue other_side = 14; */
        if (message.otherSide)
            StringValue.internalBinaryWrite(message.otherSide, writer.tag(14, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.StringValue urlForShare = 16; */
        if (message.urlForShare)
            StringValue.internalBinaryWrite(message.urlForShare, writer.tag(16, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.StringValue urlForLocal = 17; */
        if (message.urlForLocal)
            StringValue.internalBinaryWrite(message.urlForLocal, writer.tag(17, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.DoubleValue max_atr_angle = 21; */
        if (message.maxAtrAngle)
            DoubleValue.internalBinaryWrite(message.maxAtrAngle, writer.tag(21, WireType.LengthDelimited).fork(), options).join();
        /* repeated algorithm.posture.GetPostureReportResponse.DepthData depth_data = 22; */
        for (let i = 0; i < message.depthData.length; i++)
            GetPostureReportResponse_DepthData.internalBinaryWrite(message.depthData[i], writer.tag(22, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message algorithm.posture.GetPostureReportResponse
 */
export const GetPostureReportResponse = new GetPostureReportResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetPostureReportResponse_DepthData$Type extends MessageType<GetPostureReportResponse_DepthData> {
    constructor() {
        super("algorithm.posture.GetPostureReportResponse.DepthData", [
            { no: 1, name: "shooting_angle", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "keypoints", kind: "message", T: () => GetPostureReportResponse_Keypoints },
            { no: 4, name: "contour_map_moire_image_url", kind: "message", T: () => StringValue }
        ]);
    }
    create(value?: PartialMessage<GetPostureReportResponse_DepthData>): GetPostureReportResponse_DepthData {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.shootingAngle = "";
        if (value !== undefined)
            reflectionMergePartial<GetPostureReportResponse_DepthData>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetPostureReportResponse_DepthData): GetPostureReportResponse_DepthData {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string shooting_angle */ 1:
                    message.shootingAngle = reader.string();
                    break;
                case /* algorithm.posture.GetPostureReportResponse.Keypoints keypoints */ 2:
                    message.keypoints = GetPostureReportResponse_Keypoints.internalBinaryRead(reader, reader.uint32(), options, message.keypoints);
                    break;
                case /* google.protobuf.StringValue contour_map_moire_image_url */ 4:
                    message.contourMapMoireImageUrl = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.contourMapMoireImageUrl);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetPostureReportResponse_DepthData, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string shooting_angle = 1; */
        if (message.shootingAngle !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.shootingAngle);
        /* algorithm.posture.GetPostureReportResponse.Keypoints keypoints = 2; */
        if (message.keypoints)
            GetPostureReportResponse_Keypoints.internalBinaryWrite(message.keypoints, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.StringValue contour_map_moire_image_url = 4; */
        if (message.contourMapMoireImageUrl)
            StringValue.internalBinaryWrite(message.contourMapMoireImageUrl, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message algorithm.posture.GetPostureReportResponse.DepthData
 */
export const GetPostureReportResponse_DepthData = new GetPostureReportResponse_DepthData$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetPostureReportResponse_Keypoints$Type extends MessageType<GetPostureReportResponse_Keypoints> {
    constructor() {
        super("algorithm.posture.GetPostureReportResponse.Keypoints", [
            { no: 1, name: "nose", kind: "message", T: () => GetPostureReportResponse_Point },
            { no: 2, name: "neck", kind: "message", T: () => GetPostureReportResponse_Point },
            { no: 3, name: "left_shoulder", kind: "message", T: () => GetPostureReportResponse_Point },
            { no: 4, name: "right_shoulder", kind: "message", T: () => GetPostureReportResponse_Point },
            { no: 5, name: "left_elbow", kind: "message", T: () => GetPostureReportResponse_Point },
            { no: 6, name: "right_elbow", kind: "message", T: () => GetPostureReportResponse_Point },
            { no: 7, name: "left_wrist", kind: "message", T: () => GetPostureReportResponse_Point },
            { no: 8, name: "right_wrist", kind: "message", T: () => GetPostureReportResponse_Point },
            { no: 9, name: "left_hip", kind: "message", T: () => GetPostureReportResponse_Point },
            { no: 10, name: "right_hip", kind: "message", T: () => GetPostureReportResponse_Point },
            { no: 11, name: "left_knee", kind: "message", T: () => GetPostureReportResponse_Point },
            { no: 12, name: "right_knee", kind: "message", T: () => GetPostureReportResponse_Point },
            { no: 13, name: "left_ankle", kind: "message", T: () => GetPostureReportResponse_Point },
            { no: 14, name: "right_ankle", kind: "message", T: () => GetPostureReportResponse_Point },
            { no: 15, name: "left_eye", kind: "message", T: () => GetPostureReportResponse_Point },
            { no: 16, name: "right_eye", kind: "message", T: () => GetPostureReportResponse_Point },
            { no: 17, name: "left_ear", kind: "message", T: () => GetPostureReportResponse_Point },
            { no: 18, name: "right_ear", kind: "message", T: () => GetPostureReportResponse_Point },
            { no: 19, name: "left_heel", kind: "message", T: () => GetPostureReportResponse_Point },
            { no: 20, name: "right_heel", kind: "message", T: () => GetPostureReportResponse_Point }
        ]);
    }
    create(value?: PartialMessage<GetPostureReportResponse_Keypoints>): GetPostureReportResponse_Keypoints {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetPostureReportResponse_Keypoints>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetPostureReportResponse_Keypoints): GetPostureReportResponse_Keypoints {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* algorithm.posture.GetPostureReportResponse.Point nose */ 1:
                    message.nose = GetPostureReportResponse_Point.internalBinaryRead(reader, reader.uint32(), options, message.nose);
                    break;
                case /* algorithm.posture.GetPostureReportResponse.Point neck */ 2:
                    message.neck = GetPostureReportResponse_Point.internalBinaryRead(reader, reader.uint32(), options, message.neck);
                    break;
                case /* algorithm.posture.GetPostureReportResponse.Point left_shoulder */ 3:
                    message.leftShoulder = GetPostureReportResponse_Point.internalBinaryRead(reader, reader.uint32(), options, message.leftShoulder);
                    break;
                case /* algorithm.posture.GetPostureReportResponse.Point right_shoulder */ 4:
                    message.rightShoulder = GetPostureReportResponse_Point.internalBinaryRead(reader, reader.uint32(), options, message.rightShoulder);
                    break;
                case /* algorithm.posture.GetPostureReportResponse.Point left_elbow */ 5:
                    message.leftElbow = GetPostureReportResponse_Point.internalBinaryRead(reader, reader.uint32(), options, message.leftElbow);
                    break;
                case /* algorithm.posture.GetPostureReportResponse.Point right_elbow */ 6:
                    message.rightElbow = GetPostureReportResponse_Point.internalBinaryRead(reader, reader.uint32(), options, message.rightElbow);
                    break;
                case /* algorithm.posture.GetPostureReportResponse.Point left_wrist */ 7:
                    message.leftWrist = GetPostureReportResponse_Point.internalBinaryRead(reader, reader.uint32(), options, message.leftWrist);
                    break;
                case /* algorithm.posture.GetPostureReportResponse.Point right_wrist */ 8:
                    message.rightWrist = GetPostureReportResponse_Point.internalBinaryRead(reader, reader.uint32(), options, message.rightWrist);
                    break;
                case /* algorithm.posture.GetPostureReportResponse.Point left_hip */ 9:
                    message.leftHip = GetPostureReportResponse_Point.internalBinaryRead(reader, reader.uint32(), options, message.leftHip);
                    break;
                case /* algorithm.posture.GetPostureReportResponse.Point right_hip */ 10:
                    message.rightHip = GetPostureReportResponse_Point.internalBinaryRead(reader, reader.uint32(), options, message.rightHip);
                    break;
                case /* algorithm.posture.GetPostureReportResponse.Point left_knee */ 11:
                    message.leftKnee = GetPostureReportResponse_Point.internalBinaryRead(reader, reader.uint32(), options, message.leftKnee);
                    break;
                case /* algorithm.posture.GetPostureReportResponse.Point right_knee */ 12:
                    message.rightKnee = GetPostureReportResponse_Point.internalBinaryRead(reader, reader.uint32(), options, message.rightKnee);
                    break;
                case /* algorithm.posture.GetPostureReportResponse.Point left_ankle */ 13:
                    message.leftAnkle = GetPostureReportResponse_Point.internalBinaryRead(reader, reader.uint32(), options, message.leftAnkle);
                    break;
                case /* algorithm.posture.GetPostureReportResponse.Point right_ankle */ 14:
                    message.rightAnkle = GetPostureReportResponse_Point.internalBinaryRead(reader, reader.uint32(), options, message.rightAnkle);
                    break;
                case /* algorithm.posture.GetPostureReportResponse.Point left_eye */ 15:
                    message.leftEye = GetPostureReportResponse_Point.internalBinaryRead(reader, reader.uint32(), options, message.leftEye);
                    break;
                case /* algorithm.posture.GetPostureReportResponse.Point right_eye */ 16:
                    message.rightEye = GetPostureReportResponse_Point.internalBinaryRead(reader, reader.uint32(), options, message.rightEye);
                    break;
                case /* algorithm.posture.GetPostureReportResponse.Point left_ear */ 17:
                    message.leftEar = GetPostureReportResponse_Point.internalBinaryRead(reader, reader.uint32(), options, message.leftEar);
                    break;
                case /* algorithm.posture.GetPostureReportResponse.Point right_ear */ 18:
                    message.rightEar = GetPostureReportResponse_Point.internalBinaryRead(reader, reader.uint32(), options, message.rightEar);
                    break;
                case /* algorithm.posture.GetPostureReportResponse.Point left_heel */ 19:
                    message.leftHeel = GetPostureReportResponse_Point.internalBinaryRead(reader, reader.uint32(), options, message.leftHeel);
                    break;
                case /* algorithm.posture.GetPostureReportResponse.Point right_heel */ 20:
                    message.rightHeel = GetPostureReportResponse_Point.internalBinaryRead(reader, reader.uint32(), options, message.rightHeel);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetPostureReportResponse_Keypoints, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* algorithm.posture.GetPostureReportResponse.Point nose = 1; */
        if (message.nose)
            GetPostureReportResponse_Point.internalBinaryWrite(message.nose, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* algorithm.posture.GetPostureReportResponse.Point neck = 2; */
        if (message.neck)
            GetPostureReportResponse_Point.internalBinaryWrite(message.neck, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* algorithm.posture.GetPostureReportResponse.Point left_shoulder = 3; */
        if (message.leftShoulder)
            GetPostureReportResponse_Point.internalBinaryWrite(message.leftShoulder, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* algorithm.posture.GetPostureReportResponse.Point right_shoulder = 4; */
        if (message.rightShoulder)
            GetPostureReportResponse_Point.internalBinaryWrite(message.rightShoulder, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* algorithm.posture.GetPostureReportResponse.Point left_elbow = 5; */
        if (message.leftElbow)
            GetPostureReportResponse_Point.internalBinaryWrite(message.leftElbow, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* algorithm.posture.GetPostureReportResponse.Point right_elbow = 6; */
        if (message.rightElbow)
            GetPostureReportResponse_Point.internalBinaryWrite(message.rightElbow, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* algorithm.posture.GetPostureReportResponse.Point left_wrist = 7; */
        if (message.leftWrist)
            GetPostureReportResponse_Point.internalBinaryWrite(message.leftWrist, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* algorithm.posture.GetPostureReportResponse.Point right_wrist = 8; */
        if (message.rightWrist)
            GetPostureReportResponse_Point.internalBinaryWrite(message.rightWrist, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* algorithm.posture.GetPostureReportResponse.Point left_hip = 9; */
        if (message.leftHip)
            GetPostureReportResponse_Point.internalBinaryWrite(message.leftHip, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* algorithm.posture.GetPostureReportResponse.Point right_hip = 10; */
        if (message.rightHip)
            GetPostureReportResponse_Point.internalBinaryWrite(message.rightHip, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* algorithm.posture.GetPostureReportResponse.Point left_knee = 11; */
        if (message.leftKnee)
            GetPostureReportResponse_Point.internalBinaryWrite(message.leftKnee, writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        /* algorithm.posture.GetPostureReportResponse.Point right_knee = 12; */
        if (message.rightKnee)
            GetPostureReportResponse_Point.internalBinaryWrite(message.rightKnee, writer.tag(12, WireType.LengthDelimited).fork(), options).join();
        /* algorithm.posture.GetPostureReportResponse.Point left_ankle = 13; */
        if (message.leftAnkle)
            GetPostureReportResponse_Point.internalBinaryWrite(message.leftAnkle, writer.tag(13, WireType.LengthDelimited).fork(), options).join();
        /* algorithm.posture.GetPostureReportResponse.Point right_ankle = 14; */
        if (message.rightAnkle)
            GetPostureReportResponse_Point.internalBinaryWrite(message.rightAnkle, writer.tag(14, WireType.LengthDelimited).fork(), options).join();
        /* algorithm.posture.GetPostureReportResponse.Point left_eye = 15; */
        if (message.leftEye)
            GetPostureReportResponse_Point.internalBinaryWrite(message.leftEye, writer.tag(15, WireType.LengthDelimited).fork(), options).join();
        /* algorithm.posture.GetPostureReportResponse.Point right_eye = 16; */
        if (message.rightEye)
            GetPostureReportResponse_Point.internalBinaryWrite(message.rightEye, writer.tag(16, WireType.LengthDelimited).fork(), options).join();
        /* algorithm.posture.GetPostureReportResponse.Point left_ear = 17; */
        if (message.leftEar)
            GetPostureReportResponse_Point.internalBinaryWrite(message.leftEar, writer.tag(17, WireType.LengthDelimited).fork(), options).join();
        /* algorithm.posture.GetPostureReportResponse.Point right_ear = 18; */
        if (message.rightEar)
            GetPostureReportResponse_Point.internalBinaryWrite(message.rightEar, writer.tag(18, WireType.LengthDelimited).fork(), options).join();
        /* algorithm.posture.GetPostureReportResponse.Point left_heel = 19; */
        if (message.leftHeel)
            GetPostureReportResponse_Point.internalBinaryWrite(message.leftHeel, writer.tag(19, WireType.LengthDelimited).fork(), options).join();
        /* algorithm.posture.GetPostureReportResponse.Point right_heel = 20; */
        if (message.rightHeel)
            GetPostureReportResponse_Point.internalBinaryWrite(message.rightHeel, writer.tag(20, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message algorithm.posture.GetPostureReportResponse.Keypoints
 */
export const GetPostureReportResponse_Keypoints = new GetPostureReportResponse_Keypoints$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetPostureReportResponse_Point$Type extends MessageType<GetPostureReportResponse_Point> {
    constructor() {
        super("algorithm.posture.GetPostureReportResponse.Point", [
            { no: 1, name: "x", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 2, name: "y", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 3, name: "z", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ }
        ]);
    }
    create(value?: PartialMessage<GetPostureReportResponse_Point>): GetPostureReportResponse_Point {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.x = 0;
        message.y = 0;
        message.z = 0;
        if (value !== undefined)
            reflectionMergePartial<GetPostureReportResponse_Point>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetPostureReportResponse_Point): GetPostureReportResponse_Point {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* double x */ 1:
                    message.x = reader.double();
                    break;
                case /* double y */ 2:
                    message.y = reader.double();
                    break;
                case /* double z */ 3:
                    message.z = reader.double();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetPostureReportResponse_Point, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* double x = 1; */
        if (message.x !== 0)
            writer.tag(1, WireType.Bit64).double(message.x);
        /* double y = 2; */
        if (message.y !== 0)
            writer.tag(2, WireType.Bit64).double(message.y);
        /* double z = 3; */
        if (message.z !== 0)
            writer.tag(3, WireType.Bit64).double(message.z);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message algorithm.posture.GetPostureReportResponse.Point
 */
export const GetPostureReportResponse_Point = new GetPostureReportResponse_Point$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GeneralResult$Type extends MessageType<GeneralResult> {
    constructor() {
        super("algorithm.posture.GeneralResult", [
            { no: 1, name: "score", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 2, name: "level", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "percent", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ }
        ]);
    }
    create(value?: PartialMessage<GeneralResult>): GeneralResult {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.score = 0;
        message.level = "";
        message.percent = 0;
        if (value !== undefined)
            reflectionMergePartial<GeneralResult>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GeneralResult): GeneralResult {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* double score */ 1:
                    message.score = reader.double();
                    break;
                case /* string level */ 2:
                    message.level = reader.string();
                    break;
                case /* double percent */ 3:
                    message.percent = reader.double();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GeneralResult, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* double score = 1; */
        if (message.score !== 0)
            writer.tag(1, WireType.Bit64).double(message.score);
        /* string level = 2; */
        if (message.level !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.level);
        /* double percent = 3; */
        if (message.percent !== 0)
            writer.tag(3, WireType.Bit64).double(message.percent);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message algorithm.posture.GeneralResult
 */
export const GeneralResult = new GeneralResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ItemResult$Type extends MessageType<ItemResult> {
    constructor() {
        super("algorithm.posture.ItemResult", [
            { no: 1, name: "valid", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "points", kind: "message", T: () => PointsResult },
            { no: 3, name: "side", kind: "message", T: () => StringValue },
            { no: 4, name: "risks", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => RiskResult }
        ]);
    }
    create(value?: PartialMessage<ItemResult>): ItemResult {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.valid = false;
        message.risks = [];
        if (value !== undefined)
            reflectionMergePartial<ItemResult>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ItemResult): ItemResult {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool valid */ 1:
                    message.valid = reader.bool();
                    break;
                case /* algorithm.posture.PointsResult points */ 2:
                    message.points = PointsResult.internalBinaryRead(reader, reader.uint32(), options, message.points);
                    break;
                case /* google.protobuf.StringValue side */ 3:
                    message.side = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.side);
                    break;
                case /* repeated algorithm.posture.RiskResult risks */ 4:
                    message.risks.push(RiskResult.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ItemResult, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool valid = 1; */
        if (message.valid !== false)
            writer.tag(1, WireType.Varint).bool(message.valid);
        /* algorithm.posture.PointsResult points = 2; */
        if (message.points)
            PointsResult.internalBinaryWrite(message.points, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.StringValue side = 3; */
        if (message.side)
            StringValue.internalBinaryWrite(message.side, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* repeated algorithm.posture.RiskResult risks = 4; */
        for (let i = 0; i < message.risks.length; i++)
            RiskResult.internalBinaryWrite(message.risks[i], writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message algorithm.posture.ItemResult
 */
export const ItemResult = new ItemResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PointsResult$Type extends MessageType<PointsResult> {
    constructor() {
        super("algorithm.posture.PointsResult", [
            { no: 1, name: "nose", kind: "message", T: () => PointResult },
            { no: 2, name: "neck", kind: "message", T: () => PointResult },
            { no: 3, name: "shoulder", kind: "message", T: () => PartResult },
            { no: 4, name: "elbow", kind: "message", T: () => PartResult },
            { no: 5, name: "wrist", kind: "message", T: () => PartResult },
            { no: 6, name: "hip", kind: "message", T: () => PartResult },
            { no: 7, name: "knee", kind: "message", T: () => PartResult },
            { no: 8, name: "ankle", kind: "message", T: () => PartResult },
            { no: 9, name: "eye", kind: "message", T: () => PartResult },
            { no: 10, name: "ear", kind: "message", T: () => PartResult },
            { no: 11, name: "heel", kind: "message", T: () => PartResult }
        ]);
    }
    create(value?: PartialMessage<PointsResult>): PointsResult {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<PointsResult>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: PointsResult): PointsResult {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* algorithm.posture.PointResult nose */ 1:
                    message.nose = PointResult.internalBinaryRead(reader, reader.uint32(), options, message.nose);
                    break;
                case /* algorithm.posture.PointResult neck */ 2:
                    message.neck = PointResult.internalBinaryRead(reader, reader.uint32(), options, message.neck);
                    break;
                case /* algorithm.posture.PartResult shoulder */ 3:
                    message.shoulder = PartResult.internalBinaryRead(reader, reader.uint32(), options, message.shoulder);
                    break;
                case /* algorithm.posture.PartResult elbow */ 4:
                    message.elbow = PartResult.internalBinaryRead(reader, reader.uint32(), options, message.elbow);
                    break;
                case /* algorithm.posture.PartResult wrist */ 5:
                    message.wrist = PartResult.internalBinaryRead(reader, reader.uint32(), options, message.wrist);
                    break;
                case /* algorithm.posture.PartResult hip */ 6:
                    message.hip = PartResult.internalBinaryRead(reader, reader.uint32(), options, message.hip);
                    break;
                case /* algorithm.posture.PartResult knee */ 7:
                    message.knee = PartResult.internalBinaryRead(reader, reader.uint32(), options, message.knee);
                    break;
                case /* algorithm.posture.PartResult ankle */ 8:
                    message.ankle = PartResult.internalBinaryRead(reader, reader.uint32(), options, message.ankle);
                    break;
                case /* algorithm.posture.PartResult eye */ 9:
                    message.eye = PartResult.internalBinaryRead(reader, reader.uint32(), options, message.eye);
                    break;
                case /* algorithm.posture.PartResult ear */ 10:
                    message.ear = PartResult.internalBinaryRead(reader, reader.uint32(), options, message.ear);
                    break;
                case /* algorithm.posture.PartResult heel */ 11:
                    message.heel = PartResult.internalBinaryRead(reader, reader.uint32(), options, message.heel);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: PointsResult, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* algorithm.posture.PointResult nose = 1; */
        if (message.nose)
            PointResult.internalBinaryWrite(message.nose, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* algorithm.posture.PointResult neck = 2; */
        if (message.neck)
            PointResult.internalBinaryWrite(message.neck, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* algorithm.posture.PartResult shoulder = 3; */
        if (message.shoulder)
            PartResult.internalBinaryWrite(message.shoulder, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* algorithm.posture.PartResult elbow = 4; */
        if (message.elbow)
            PartResult.internalBinaryWrite(message.elbow, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* algorithm.posture.PartResult wrist = 5; */
        if (message.wrist)
            PartResult.internalBinaryWrite(message.wrist, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* algorithm.posture.PartResult hip = 6; */
        if (message.hip)
            PartResult.internalBinaryWrite(message.hip, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* algorithm.posture.PartResult knee = 7; */
        if (message.knee)
            PartResult.internalBinaryWrite(message.knee, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* algorithm.posture.PartResult ankle = 8; */
        if (message.ankle)
            PartResult.internalBinaryWrite(message.ankle, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* algorithm.posture.PartResult eye = 9; */
        if (message.eye)
            PartResult.internalBinaryWrite(message.eye, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* algorithm.posture.PartResult ear = 10; */
        if (message.ear)
            PartResult.internalBinaryWrite(message.ear, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* algorithm.posture.PartResult heel = 11; */
        if (message.heel)
            PartResult.internalBinaryWrite(message.heel, writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message algorithm.posture.PointsResult
 */
export const PointsResult = new PointsResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PartResult$Type extends MessageType<PartResult> {
    constructor() {
        super("algorithm.posture.PartResult", [
            { no: 1, name: "left", kind: "message", T: () => PointResult },
            { no: 2, name: "right", kind: "message", T: () => PointResult }
        ]);
    }
    create(value?: PartialMessage<PartResult>): PartResult {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<PartResult>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: PartResult): PartResult {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* algorithm.posture.PointResult left */ 1:
                    message.left = PointResult.internalBinaryRead(reader, reader.uint32(), options, message.left);
                    break;
                case /* algorithm.posture.PointResult right */ 2:
                    message.right = PointResult.internalBinaryRead(reader, reader.uint32(), options, message.right);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: PartResult, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* algorithm.posture.PointResult left = 1; */
        if (message.left)
            PointResult.internalBinaryWrite(message.left, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* algorithm.posture.PointResult right = 2; */
        if (message.right)
            PointResult.internalBinaryWrite(message.right, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message algorithm.posture.PartResult
 */
export const PartResult = new PartResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PointResult$Type extends MessageType<PointResult> {
    constructor() {
        super("algorithm.posture.PointResult", [
            { no: 1, name: "x", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 2, name: "y", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ }
        ]);
    }
    create(value?: PartialMessage<PointResult>): PointResult {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.x = 0;
        message.y = 0;
        if (value !== undefined)
            reflectionMergePartial<PointResult>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: PointResult): PointResult {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* double x */ 1:
                    message.x = reader.double();
                    break;
                case /* double y */ 2:
                    message.y = reader.double();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: PointResult, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* double x = 1; */
        if (message.x !== 0)
            writer.tag(1, WireType.Bit64).double(message.x);
        /* double y = 2; */
        if (message.y !== 0)
            writer.tag(2, WireType.Bit64).double(message.y);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message algorithm.posture.PointResult
 */
export const PointResult = new PointResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RiskResult$Type extends MessageType<RiskResult> {
    constructor() {
        super("algorithm.posture.RiskResult", [
            { no: 1, name: "id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "position", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "code", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "key", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "raw", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 7, name: "direction", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "value", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 9, name: "level", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "detail", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 12, name: "valid", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 13, name: "meanValue", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ }
        ]);
    }
    create(value?: PartialMessage<RiskResult>): RiskResult {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = 0;
        message.position = "";
        message.code = 0;
        message.key = "";
        message.name = "";
        message.raw = 0;
        message.direction = "";
        message.value = 0;
        message.level = "";
        message.description = "";
        message.detail = "";
        message.valid = false;
        message.meanValue = 0;
        if (value !== undefined)
            reflectionMergePartial<RiskResult>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RiskResult): RiskResult {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 id */ 1:
                    message.id = reader.int32();
                    break;
                case /* string position */ 2:
                    message.position = reader.string();
                    break;
                case /* int32 code */ 3:
                    message.code = reader.int32();
                    break;
                case /* string key */ 4:
                    message.key = reader.string();
                    break;
                case /* string name */ 5:
                    message.name = reader.string();
                    break;
                case /* double raw */ 6:
                    message.raw = reader.double();
                    break;
                case /* string direction */ 7:
                    message.direction = reader.string();
                    break;
                case /* double value */ 8:
                    message.value = reader.double();
                    break;
                case /* string level */ 9:
                    message.level = reader.string();
                    break;
                case /* string description */ 10:
                    message.description = reader.string();
                    break;
                case /* string detail */ 11:
                    message.detail = reader.string();
                    break;
                case /* bool valid */ 12:
                    message.valid = reader.bool();
                    break;
                case /* double meanValue */ 13:
                    message.meanValue = reader.double();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RiskResult, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).int32(message.id);
        /* string position = 2; */
        if (message.position !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.position);
        /* int32 code = 3; */
        if (message.code !== 0)
            writer.tag(3, WireType.Varint).int32(message.code);
        /* string key = 4; */
        if (message.key !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.key);
        /* string name = 5; */
        if (message.name !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.name);
        /* double raw = 6; */
        if (message.raw !== 0)
            writer.tag(6, WireType.Bit64).double(message.raw);
        /* string direction = 7; */
        if (message.direction !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.direction);
        /* double value = 8; */
        if (message.value !== 0)
            writer.tag(8, WireType.Bit64).double(message.value);
        /* string level = 9; */
        if (message.level !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.level);
        /* string description = 10; */
        if (message.description !== "")
            writer.tag(10, WireType.LengthDelimited).string(message.description);
        /* string detail = 11; */
        if (message.detail !== "")
            writer.tag(11, WireType.LengthDelimited).string(message.detail);
        /* bool valid = 12; */
        if (message.valid !== false)
            writer.tag(12, WireType.Varint).bool(message.valid);
        /* double meanValue = 13; */
        if (message.meanValue !== 0)
            writer.tag(13, WireType.Bit64).double(message.meanValue);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message algorithm.posture.RiskResult
 */
export const RiskResult = new RiskResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TagResult$Type extends MessageType<TagResult> {
    constructor() {
        super("algorithm.posture.TagResult", [
            { no: 2, name: "code", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "result", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<TagResult>): TagResult {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.code = 0;
        message.result = "";
        if (value !== undefined)
            reflectionMergePartial<TagResult>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TagResult): TagResult {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 code */ 2:
                    message.code = reader.int32();
                    break;
                case /* string result */ 3:
                    message.result = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TagResult, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 code = 2; */
        if (message.code !== 0)
            writer.tag(2, WireType.Varint).int32(message.code);
        /* string result = 3; */
        if (message.result !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.result);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message algorithm.posture.TagResult
 */
export const TagResult = new TagResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ResultResult$Type extends MessageType<ResultResult> {
    constructor() {
        super("algorithm.posture.ResultResult", [
            { no: 2, name: "code", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<ResultResult>): ResultResult {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.code = 0;
        message.name = "";
        message.description = "";
        if (value !== undefined)
            reflectionMergePartial<ResultResult>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ResultResult): ResultResult {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 code */ 2:
                    message.code = reader.int32();
                    break;
                case /* string name */ 3:
                    message.name = reader.string();
                    break;
                case /* string description */ 4:
                    message.description = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ResultResult, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 code = 2; */
        if (message.code !== 0)
            writer.tag(2, WireType.Varint).int32(message.code);
        /* string name = 3; */
        if (message.name !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.name);
        /* string description = 4; */
        if (message.description !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.description);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message algorithm.posture.ResultResult
 */
export const ResultResult = new ResultResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListSymptomsResponse$Type extends MessageType<ListSymptomsResponse> {
    constructor() {
        super("algorithm.posture.ListSymptomsResponse", [
            { no: 1, name: "symptoms", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ListSymptomsResponse_Symptom }
        ]);
    }
    create(value?: PartialMessage<ListSymptomsResponse>): ListSymptomsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.symptoms = [];
        if (value !== undefined)
            reflectionMergePartial<ListSymptomsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListSymptomsResponse): ListSymptomsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated algorithm.posture.ListSymptomsResponse.Symptom symptoms */ 1:
                    message.symptoms.push(ListSymptomsResponse_Symptom.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListSymptomsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated algorithm.posture.ListSymptomsResponse.Symptom symptoms = 1; */
        for (let i = 0; i < message.symptoms.length; i++)
            ListSymptomsResponse_Symptom.internalBinaryWrite(message.symptoms[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message algorithm.posture.ListSymptomsResponse
 */
export const ListSymptomsResponse = new ListSymptomsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListSymptomsResponse_Symptom$Type extends MessageType<ListSymptomsResponse_Symptom> {
    constructor() {
        super("algorithm.posture.ListSymptomsResponse.Symptom", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "extra", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "level", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "level_display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<ListSymptomsResponse_Symptom>): ListSymptomsResponse_Symptom {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.name = "";
        message.extra = "";
        message.displayName = "";
        message.level = "";
        message.levelDisplayName = "";
        if (value !== undefined)
            reflectionMergePartial<ListSymptomsResponse_Symptom>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListSymptomsResponse_Symptom): ListSymptomsResponse_Symptom {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string name */ 1:
                    message.name = reader.string();
                    break;
                case /* string extra */ 2:
                    message.extra = reader.string();
                    break;
                case /* string display_name */ 3:
                    message.displayName = reader.string();
                    break;
                case /* string level */ 4:
                    message.level = reader.string();
                    break;
                case /* string level_display_name */ 5:
                    message.levelDisplayName = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListSymptomsResponse_Symptom, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string name = 1; */
        if (message.name !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.name);
        /* string extra = 2; */
        if (message.extra !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.extra);
        /* string display_name = 3; */
        if (message.displayName !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.displayName);
        /* string level = 4; */
        if (message.level !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.level);
        /* string level_display_name = 5; */
        if (message.levelDisplayName !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.levelDisplayName);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message algorithm.posture.ListSymptomsResponse.Symptom
 */
export const ListSymptomsResponse_Symptom = new ListSymptomsResponse_Symptom$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetPresignedPutObjectUrlRequest$Type extends MessageType<GetPresignedPutObjectUrlRequest> {
    constructor() {
        super("algorithm.posture.GetPresignedPutObjectUrlRequest", [
            { no: 1, name: "object_type", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "key", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<GetPresignedPutObjectUrlRequest>): GetPresignedPutObjectUrlRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.objectType = "";
        message.key = "";
        if (value !== undefined)
            reflectionMergePartial<GetPresignedPutObjectUrlRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetPresignedPutObjectUrlRequest): GetPresignedPutObjectUrlRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string object_type */ 1:
                    message.objectType = reader.string();
                    break;
                case /* string key */ 2:
                    message.key = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetPresignedPutObjectUrlRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string object_type = 1; */
        if (message.objectType !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.objectType);
        /* string key = 2; */
        if (message.key !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.key);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message algorithm.posture.GetPresignedPutObjectUrlRequest
 */
export const GetPresignedPutObjectUrlRequest = new GetPresignedPutObjectUrlRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetPresignedPutObjectUrlResponse$Type extends MessageType<GetPresignedPutObjectUrlResponse> {
    constructor() {
        super("algorithm.posture.GetPresignedPutObjectUrlResponse", [
            { no: 1, name: "key", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "url", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<GetPresignedPutObjectUrlResponse>): GetPresignedPutObjectUrlResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.key = "";
        message.url = "";
        if (value !== undefined)
            reflectionMergePartial<GetPresignedPutObjectUrlResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetPresignedPutObjectUrlResponse): GetPresignedPutObjectUrlResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string key */ 1:
                    message.key = reader.string();
                    break;
                case /* string url */ 2:
                    message.url = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetPresignedPutObjectUrlResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string key = 1; */
        if (message.key !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.key);
        /* string url = 2; */
        if (message.url !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.url);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message algorithm.posture.GetPresignedPutObjectUrlResponse
 */
export const GetPresignedPutObjectUrlResponse = new GetPresignedPutObjectUrlResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListReportTypesRequest$Type extends MessageType<ListReportTypesRequest> {
    constructor() {
        super("algorithm.posture.ListReportTypesRequest", []);
    }
    create(value?: PartialMessage<ListReportTypesRequest>): ListReportTypesRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<ListReportTypesRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListReportTypesRequest): ListReportTypesRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListReportTypesRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message algorithm.posture.ListReportTypesRequest
 */
export const ListReportTypesRequest = new ListReportTypesRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListReportTypesResponse$Type extends MessageType<ListReportTypesResponse> {
    constructor() {
        super("algorithm.posture.ListReportTypesResponse", [
            { no: 1, name: "report_types", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ReportType }
        ]);
    }
    create(value?: PartialMessage<ListReportTypesResponse>): ListReportTypesResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.reportTypes = [];
        if (value !== undefined)
            reflectionMergePartial<ListReportTypesResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListReportTypesResponse): ListReportTypesResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated algorithm.posture.ReportType report_types */ 1:
                    message.reportTypes.push(ReportType.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListReportTypesResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated algorithm.posture.ReportType report_types = 1; */
        for (let i = 0; i < message.reportTypes.length; i++)
            ReportType.internalBinaryWrite(message.reportTypes[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message algorithm.posture.ListReportTypesResponse
 */
export const ListReportTypesResponse = new ListReportTypesResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ReportType$Type extends MessageType<ReportType> {
    constructor() {
        super("algorithm.posture.ReportType", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<ReportType>): ReportType {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.name = "";
        message.displayName = "";
        if (value !== undefined)
            reflectionMergePartial<ReportType>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ReportType): ReportType {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string name */ 1:
                    message.name = reader.string();
                    break;
                case /* string display_name */ 2:
                    message.displayName = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ReportType, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string name = 1; */
        if (message.name !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.name);
        /* string display_name = 2; */
        if (message.displayName !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.displayName);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message algorithm.posture.ReportType
 */
export const ReportType = new ReportType$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AssignReportTypeByOrganizationIdRequest$Type extends MessageType<AssignReportTypeByOrganizationIdRequest> {
    constructor() {
        super("algorithm.posture.AssignReportTypeByOrganizationIdRequest", [
            { no: 1, name: "organization_id", kind: "scalar", T: 3 /*ScalarType.INT64*/ },
            { no: 2, name: "report_type", kind: "message", T: () => ReportType }
        ]);
    }
    create(value?: PartialMessage<AssignReportTypeByOrganizationIdRequest>): AssignReportTypeByOrganizationIdRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.organizationId = "0";
        if (value !== undefined)
            reflectionMergePartial<AssignReportTypeByOrganizationIdRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AssignReportTypeByOrganizationIdRequest): AssignReportTypeByOrganizationIdRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 organization_id */ 1:
                    message.organizationId = reader.int64().toString();
                    break;
                case /* algorithm.posture.ReportType report_type */ 2:
                    message.reportType = ReportType.internalBinaryRead(reader, reader.uint32(), options, message.reportType);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AssignReportTypeByOrganizationIdRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 organization_id = 1; */
        if (message.organizationId !== "0")
            writer.tag(1, WireType.Varint).int64(message.organizationId);
        /* algorithm.posture.ReportType report_type = 2; */
        if (message.reportType)
            ReportType.internalBinaryWrite(message.reportType, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message algorithm.posture.AssignReportTypeByOrganizationIdRequest
 */
export const AssignReportTypeByOrganizationIdRequest = new AssignReportTypeByOrganizationIdRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AssignReportTypeByOrganizationIdResponse$Type extends MessageType<AssignReportTypeByOrganizationIdResponse> {
    constructor() {
        super("algorithm.posture.AssignReportTypeByOrganizationIdResponse", [
            { no: 1, name: "organization_id", kind: "scalar", T: 3 /*ScalarType.INT64*/ },
            { no: 2, name: "report_type", kind: "message", T: () => ReportType }
        ]);
    }
    create(value?: PartialMessage<AssignReportTypeByOrganizationIdResponse>): AssignReportTypeByOrganizationIdResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.organizationId = "0";
        if (value !== undefined)
            reflectionMergePartial<AssignReportTypeByOrganizationIdResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AssignReportTypeByOrganizationIdResponse): AssignReportTypeByOrganizationIdResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 organization_id */ 1:
                    message.organizationId = reader.int64().toString();
                    break;
                case /* algorithm.posture.ReportType report_type */ 2:
                    message.reportType = ReportType.internalBinaryRead(reader, reader.uint32(), options, message.reportType);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AssignReportTypeByOrganizationIdResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 organization_id = 1; */
        if (message.organizationId !== "0")
            writer.tag(1, WireType.Varint).int64(message.organizationId);
        /* algorithm.posture.ReportType report_type = 2; */
        if (message.reportType)
            ReportType.internalBinaryWrite(message.reportType, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message algorithm.posture.AssignReportTypeByOrganizationIdResponse
 */
export const AssignReportTypeByOrganizationIdResponse = new AssignReportTypeByOrganizationIdResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetReportTypeByOrganizationIdRequest$Type extends MessageType<GetReportTypeByOrganizationIdRequest> {
    constructor() {
        super("algorithm.posture.GetReportTypeByOrganizationIdRequest", [
            { no: 1, name: "organization_id", kind: "scalar", T: 3 /*ScalarType.INT64*/ }
        ]);
    }
    create(value?: PartialMessage<GetReportTypeByOrganizationIdRequest>): GetReportTypeByOrganizationIdRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.organizationId = "0";
        if (value !== undefined)
            reflectionMergePartial<GetReportTypeByOrganizationIdRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetReportTypeByOrganizationIdRequest): GetReportTypeByOrganizationIdRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 organization_id */ 1:
                    message.organizationId = reader.int64().toString();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetReportTypeByOrganizationIdRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 organization_id = 1; */
        if (message.organizationId !== "0")
            writer.tag(1, WireType.Varint).int64(message.organizationId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message algorithm.posture.GetReportTypeByOrganizationIdRequest
 */
export const GetReportTypeByOrganizationIdRequest = new GetReportTypeByOrganizationIdRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetReportTypeByOrganizationIdResponse$Type extends MessageType<GetReportTypeByOrganizationIdResponse> {
    constructor() {
        super("algorithm.posture.GetReportTypeByOrganizationIdResponse", [
            { no: 1, name: "report_type", kind: "message", T: () => ReportType }
        ]);
    }
    create(value?: PartialMessage<GetReportTypeByOrganizationIdResponse>): GetReportTypeByOrganizationIdResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetReportTypeByOrganizationIdResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetReportTypeByOrganizationIdResponse): GetReportTypeByOrganizationIdResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* algorithm.posture.ReportType report_type */ 1:
                    message.reportType = ReportType.internalBinaryRead(reader, reader.uint32(), options, message.reportType);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetReportTypeByOrganizationIdResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* algorithm.posture.ReportType report_type = 1; */
        if (message.reportType)
            ReportType.internalBinaryWrite(message.reportType, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message algorithm.posture.GetReportTypeByOrganizationIdResponse
 */
export const GetReportTypeByOrganizationIdResponse = new GetReportTypeByOrganizationIdResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListReportsWithoutOrganizationIdRequest$Type extends MessageType<ListReportsWithoutOrganizationIdRequest> {
    constructor() {
        super("algorithm.posture.ListReportsWithoutOrganizationIdRequest", [
            { no: 1, name: "page_num", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "account_id", kind: "message", T: () => Int64Value }
        ]);
    }
    create(value?: PartialMessage<ListReportsWithoutOrganizationIdRequest>): ListReportsWithoutOrganizationIdRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.pageNum = 0;
        message.pageSize = 0;
        if (value !== undefined)
            reflectionMergePartial<ListReportsWithoutOrganizationIdRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListReportsWithoutOrganizationIdRequest): ListReportsWithoutOrganizationIdRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 page_num */ 1:
                    message.pageNum = reader.int32();
                    break;
                case /* int32 page_size */ 2:
                    message.pageSize = reader.int32();
                    break;
                case /* google.protobuf.Int64Value account_id */ 3:
                    message.accountId = Int64Value.internalBinaryRead(reader, reader.uint32(), options, message.accountId);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListReportsWithoutOrganizationIdRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 page_num = 1; */
        if (message.pageNum !== 0)
            writer.tag(1, WireType.Varint).int32(message.pageNum);
        /* int32 page_size = 2; */
        if (message.pageSize !== 0)
            writer.tag(2, WireType.Varint).int32(message.pageSize);
        /* google.protobuf.Int64Value account_id = 3; */
        if (message.accountId)
            Int64Value.internalBinaryWrite(message.accountId, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message algorithm.posture.ListReportsWithoutOrganizationIdRequest
 */
export const ListReportsWithoutOrganizationIdRequest = new ListReportsWithoutOrganizationIdRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListReportsWithoutOrganizationIdResponse$Type extends MessageType<ListReportsWithoutOrganizationIdResponse> {
    constructor() {
        super("algorithm.posture.ListReportsWithoutOrganizationIdResponse", [
            { no: 1, name: "headers", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ListReportsWithoutOrganizationIdResponse_Header },
            { no: 2, name: "total_elements", kind: "scalar", T: 3 /*ScalarType.INT64*/ },
            { no: 3, name: "total_pages", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "is_first", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 5, name: "is_last", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 6, name: "page_elements", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 7, name: "page_num", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 8, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<ListReportsWithoutOrganizationIdResponse>): ListReportsWithoutOrganizationIdResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.headers = [];
        message.totalElements = "0";
        message.totalPages = 0;
        message.isFirst = false;
        message.isLast = false;
        message.pageElements = 0;
        message.pageNum = 0;
        message.pageSize = 0;
        if (value !== undefined)
            reflectionMergePartial<ListReportsWithoutOrganizationIdResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListReportsWithoutOrganizationIdResponse): ListReportsWithoutOrganizationIdResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated algorithm.posture.ListReportsWithoutOrganizationIdResponse.Header headers */ 1:
                    message.headers.push(ListReportsWithoutOrganizationIdResponse_Header.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int64 total_elements */ 2:
                    message.totalElements = reader.int64().toString();
                    break;
                case /* int32 total_pages */ 3:
                    message.totalPages = reader.int32();
                    break;
                case /* bool is_first */ 4:
                    message.isFirst = reader.bool();
                    break;
                case /* bool is_last */ 5:
                    message.isLast = reader.bool();
                    break;
                case /* int32 page_elements */ 6:
                    message.pageElements = reader.int32();
                    break;
                case /* int32 page_num */ 7:
                    message.pageNum = reader.int32();
                    break;
                case /* int32 page_size */ 8:
                    message.pageSize = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListReportsWithoutOrganizationIdResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated algorithm.posture.ListReportsWithoutOrganizationIdResponse.Header headers = 1; */
        for (let i = 0; i < message.headers.length; i++)
            ListReportsWithoutOrganizationIdResponse_Header.internalBinaryWrite(message.headers[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int64 total_elements = 2; */
        if (message.totalElements !== "0")
            writer.tag(2, WireType.Varint).int64(message.totalElements);
        /* int32 total_pages = 3; */
        if (message.totalPages !== 0)
            writer.tag(3, WireType.Varint).int32(message.totalPages);
        /* bool is_first = 4; */
        if (message.isFirst !== false)
            writer.tag(4, WireType.Varint).bool(message.isFirst);
        /* bool is_last = 5; */
        if (message.isLast !== false)
            writer.tag(5, WireType.Varint).bool(message.isLast);
        /* int32 page_elements = 6; */
        if (message.pageElements !== 0)
            writer.tag(6, WireType.Varint).int32(message.pageElements);
        /* int32 page_num = 7; */
        if (message.pageNum !== 0)
            writer.tag(7, WireType.Varint).int32(message.pageNum);
        /* int32 page_size = 8; */
        if (message.pageSize !== 0)
            writer.tag(8, WireType.Varint).int32(message.pageSize);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message algorithm.posture.ListReportsWithoutOrganizationIdResponse
 */
export const ListReportsWithoutOrganizationIdResponse = new ListReportsWithoutOrganizationIdResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListReportsWithoutOrganizationIdResponse_Header$Type extends MessageType<ListReportsWithoutOrganizationIdResponse_Header> {
    constructor() {
        super("algorithm.posture.ListReportsWithoutOrganizationIdResponse.Header", [
            { no: 1, name: "account_id", kind: "message", T: () => Int64Value },
            { no: 2, name: "uuid", kind: "message", T: () => StringValue }
        ]);
    }
    create(value?: PartialMessage<ListReportsWithoutOrganizationIdResponse_Header>): ListReportsWithoutOrganizationIdResponse_Header {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<ListReportsWithoutOrganizationIdResponse_Header>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListReportsWithoutOrganizationIdResponse_Header): ListReportsWithoutOrganizationIdResponse_Header {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* google.protobuf.Int64Value account_id */ 1:
                    message.accountId = Int64Value.internalBinaryRead(reader, reader.uint32(), options, message.accountId);
                    break;
                case /* google.protobuf.StringValue uuid */ 2:
                    message.uuid = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.uuid);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListReportsWithoutOrganizationIdResponse_Header, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* google.protobuf.Int64Value account_id = 1; */
        if (message.accountId)
            Int64Value.internalBinaryWrite(message.accountId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.StringValue uuid = 2; */
        if (message.uuid)
            StringValue.internalBinaryWrite(message.uuid, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message algorithm.posture.ListReportsWithoutOrganizationIdResponse.Header
 */
export const ListReportsWithoutOrganizationIdResponse_Header = new ListReportsWithoutOrganizationIdResponse_Header$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RestoreReportOrganizationIdRequest$Type extends MessageType<RestoreReportOrganizationIdRequest> {
    constructor() {
        super("algorithm.posture.RestoreReportOrganizationIdRequest", [
            { no: 1, name: "uuid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "organization_id", kind: "scalar", T: 3 /*ScalarType.INT64*/ }
        ]);
    }
    create(value?: PartialMessage<RestoreReportOrganizationIdRequest>): RestoreReportOrganizationIdRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.uuid = "";
        message.organizationId = "0";
        if (value !== undefined)
            reflectionMergePartial<RestoreReportOrganizationIdRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RestoreReportOrganizationIdRequest): RestoreReportOrganizationIdRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string uuid */ 1:
                    message.uuid = reader.string();
                    break;
                case /* int64 organization_id */ 2:
                    message.organizationId = reader.int64().toString();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RestoreReportOrganizationIdRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string uuid = 1; */
        if (message.uuid !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.uuid);
        /* int64 organization_id = 2; */
        if (message.organizationId !== "0")
            writer.tag(2, WireType.Varint).int64(message.organizationId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message algorithm.posture.RestoreReportOrganizationIdRequest
 */
export const RestoreReportOrganizationIdRequest = new RestoreReportOrganizationIdRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ReprocessPostureDataRequest$Type extends MessageType<ReprocessPostureDataRequest> {
    constructor() {
        super("algorithm.posture.ReprocessPostureDataRequest", [
            { no: 1, name: "old_uuid", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<ReprocessPostureDataRequest>): ReprocessPostureDataRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.oldUuid = "";
        if (value !== undefined)
            reflectionMergePartial<ReprocessPostureDataRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ReprocessPostureDataRequest): ReprocessPostureDataRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string old_uuid */ 1:
                    message.oldUuid = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ReprocessPostureDataRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string old_uuid = 1; */
        if (message.oldUuid !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.oldUuid);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message algorithm.posture.ReprocessPostureDataRequest
 */
export const ReprocessPostureDataRequest = new ReprocessPostureDataRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ReprocessPostureDataResponse$Type extends MessageType<ReprocessPostureDataResponse> {
    constructor() {
        super("algorithm.posture.ReprocessPostureDataResponse", [
            { no: 1, name: "new_uuid", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<ReprocessPostureDataResponse>): ReprocessPostureDataResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.newUuid = "";
        if (value !== undefined)
            reflectionMergePartial<ReprocessPostureDataResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ReprocessPostureDataResponse): ReprocessPostureDataResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string new_uuid */ 1:
                    message.newUuid = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ReprocessPostureDataResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string new_uuid = 1; */
        if (message.newUuid !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.newUuid);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message algorithm.posture.ReprocessPostureDataResponse
 */
export const ReprocessPostureDataResponse = new ReprocessPostureDataResponse$Type();
/**
 * @generated ServiceType for protobuf service algorithm.posture.PostureService
 */
export const PostureService = new ServiceType("algorithm.posture.PostureService", [
    { name: "UploadPosture", options: { "google.api.http": { post: "/algorithm.posture.PostureService/UploadPosture", body: "*" } }, I: UploadPostureRequest, O: UploadPostureResponse },
    { name: "GetPostureReport", options: { "google.api.http": { post: "/algorithm.posture.PostureService/GetPostureReport", body: "*" } }, I: GetPostureReportRequest, O: GetPostureReportResponse },
    { name: "GetPostureReportList", options: { "google.api.http": { post: "/algorithm.posture.PostureService/GetPostureReportList", body: "*" } }, I: GetPostureReportListRequest, O: GetPostureReportListResponse },
    { name: "GetReportHeader", options: { "google.api.http": { post: "/algorithm.posture.PostureService/GetReportHeader", body: "*" } }, I: GetReportHeaderRequest, O: ReportHeader },
    { name: "UploadPostureCallback", options: { "google.api.http": { post: "/algorithm.posture.PostureService/UploadPostureCallback", body: "*" } }, I: UploadPostureCallbackRequest, O: UploadPostureCallbackResponse },
    { name: "GetRiskDetailByRiskIds", options: { "google.api.http": { post: "/algorithm.posture.PostureService/GetRiskDetailByRiskIds", body: "*" } }, I: GetRiskDetailByRiskIdsRequest, O: GetRiskDetailByRiskIdsResponse },
    { name: "IssueLicense", options: {}, I: IssueLicenseRequest, O: IssueLicenseResponse },
    { name: "IssueOrganizationLicense", options: { "google.api.http": { post: "/algorithm.posture.PostureService/IssueOrganizationLicense", body: "*" } }, I: IssueOrganizationLicenseRequest, O: IssueOrganizationLicenseResponse },
    { name: "IssueAccountLicense", options: {}, I: IssueAccountLicenseRequest, O: IssueAccountLicenseResponse },
    { name: "GetMuscleState", options: { "google.api.http": { post: "/algorithm.posture.PostureService/GetMuscleState", body: "*" } }, I: GetMuscleStateRequest, O: GetMuscleStateResponse },
    { name: "UpdatePostureReportCoordinate", options: { "google.api.http": { post: "/algorithm.posture.PostureService/UpdatePostureReportCoordinate", body: "*" } }, I: UpdatePostureReportCoordinateRequest, O: UpdatePostureReportCoordinateResponse },
    { name: "GetLicenseInfoByAccountIds", options: { "google.api.http": { post: "/algorithm.posture.PostureService/GetLicenseInfoByAccountIds", body: "*" } }, I: GetLicenseInfoByAccountIdsRequest, O: GetLicenseInfoByAccountIdsResponse },
    { name: "GetLicenseInfo", options: { "google.api.http": { post: "/algorithm.posture.PostureService/GetLicenseInfo", body: "*" } }, I: GetLicenseInfoRequest, O: GetLicenseInfoResponse },
    { name: "GetPostureReportHeaderList", options: { "google.api.http": { post: "/algorithm.posture.PostureService/GetPostureReportHeaderList", body: "*" } }, I: GetPostureReportHeaderListRequest, O: GetPostureReportHeaderListResponse },
    { name: "GetLicenseInfoByAccountIdAndClient", options: { "google.api.http": { post: "/algorithm.posture.PostureService/GetLicenseInfoByAccountIdAndClient", body: "*" } }, I: GetLicenseInfoByAccountIdAndClientRequest, O: GetLicenseInfoByAccountIdAndClientResponse },
    { name: "GetLicenseInfoByAccessTokenAndClient", options: { "google.api.http": { post: "/algorithm.posture.PostureService/GetLicenseInfoByAccessTokenAndClient", body: "*" } }, I: GetLicenseInfoByAccessTokenAndClientRequest, O: GetLicenseInfoByAccessTokenAndClientResponse },
    { name: "GetLicenseInfoByOrganizationIdAndClient", options: { "google.api.http": { get: "/algorithm.posture.PostureService/GetLicenseInfoByOrganizationIdAndClient", body: "*" } }, I: GetLicenseInfoByOrganizationIdAndClientRequest, O: GetLicenseInfoByOrganizationIdAndClientResponse },
    { name: "ListSymptoms", options: { "google.api.http": { get: "/algorithm.posture.PostureService/ListSymptoms", body: "*" } }, I: Empty, O: ListSymptomsResponse },
    { name: "GetPresignedPutObjectUrl", options: { "google.api.http": { get: "/algorithm.posture.PostureService/GetPresignedPutObjectUrl" } }, I: GetPresignedPutObjectUrlRequest, O: GetPresignedPutObjectUrlResponse },
    { name: "ListReportTypes", options: { "google.api.http": { get: "/algorithm.posture.PostureService/ListReportTypes" } }, I: ListReportTypesRequest, O: ListReportTypesResponse },
    { name: "AssignReportTypeByOrganizationId", options: { "google.api.http": { post: "/algorithm.posture.PostureService/AssignReportTypeByOrganizationId", body: "*" } }, I: AssignReportTypeByOrganizationIdRequest, O: AssignReportTypeByOrganizationIdResponse },
    { name: "GetReportTypeByOrganizationId", options: { "google.api.http": { get: "/algorithm.posture.PostureService/GetReportTypeByOrganizationId" } }, I: GetReportTypeByOrganizationIdRequest, O: GetReportTypeByOrganizationIdResponse },
    { name: "ListReportsWithoutOrganizationId", options: {}, I: ListReportsWithoutOrganizationIdRequest, O: ListReportsWithoutOrganizationIdResponse },
    { name: "RestoreReportOrganizationId", options: {}, I: RestoreReportOrganizationIdRequest, O: Empty },
    { name: "ReprocessPostureData", options: {}, I: ReprocessPostureDataRequest, O: ReprocessPostureDataResponse }
]);
